(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('react'), require('react-dom'), require('moment')) :
  typeof define === 'function' && define.amd ? define(['exports', 'react', 'react-dom', 'moment'], factory) :
  (factory((global.bereDatetime = {}),global.React,global.ReactDOM,global.moment));
}(this, (function (exports,React,ReactDOM,moment) { 'use strict';

  React = React && React.hasOwnProperty('default') ? React['default'] : React;
  ReactDOM = ReactDOM && ReactDOM.hasOwnProperty('default') ? ReactDOM['default'] : ReactDOM;
  moment = moment && moment.hasOwnProperty('default') ? moment['default'] : moment;

  function _typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      _typeof = function (obj) {
        return typeof obj;
      };
    } else {
      _typeof = function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof(obj);
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function _extends() {
    _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends.apply(this, arguments);
  }

  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};
      var ownKeys = Object.keys(source);

      if (typeof Object.getOwnPropertySymbols === 'function') {
        ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
          return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
      }

      ownKeys.forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    }

    return target;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }

  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }

  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };

    return _setPrototypeOf(o, p);
  }

  function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;

    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }

    return target;
  }

  function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};

    var target = _objectWithoutPropertiesLoose(source, excluded);

    var key, i;

    if (Object.getOwnPropertySymbols) {
      var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

      for (i = 0; i < sourceSymbolKeys.length; i++) {
        key = sourceSymbolKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
      }
    }

    return target;
  }

  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return self;
  }

  function _possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) {
      return call;
    }

    return _assertThisInitialized(self);
  }

  function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
  }

  function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) {
      for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

      return arr2;
    }
  }

  function _iterableToArray(iter) {
    if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
  }

  function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance");
  }

  var commonjsGlobal = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

  function createCommonjsModule(fn, module) {
  	return module = { exports: {} }, fn(module, module.exports), module.exports;
  }

  var classnames = createCommonjsModule(function (module) {
  /*!
    Copyright (c) 2016 Jed Watson.
    Licensed under the MIT License (MIT), see
    http://jedwatson.github.io/classnames
  */
  /* global define */

  (function () {

  	var hasOwn = {}.hasOwnProperty;

  	function classNames () {
  		var classes = [];

  		for (var i = 0; i < arguments.length; i++) {
  			var arg = arguments[i];
  			if (!arg) continue;

  			var argType = typeof arg;

  			if (argType === 'string' || argType === 'number') {
  				classes.push(arg);
  			} else if (Array.isArray(arg)) {
  				classes.push(classNames.apply(null, arg));
  			} else if (argType === 'object') {
  				for (var key in arg) {
  					if (hasOwn.call(arg, key) && arg[key]) {
  						classes.push(key);
  					}
  				}
  			}
  		}

  		return classes.join(' ');
  	}

  	if (module.exports) {
  		module.exports = classNames;
  	} else if (typeof undefined === 'function' && typeof undefined.amd === 'object' && undefined.amd) {
  		// register as 'classnames', consistent with npm package name
  		undefined('classnames', [], function () {
  			return classNames;
  		});
  	} else {
  		window.classNames = classNames;
  	}
  }());
  });

  var classnames$1 = createCommonjsModule(function (module) {
  /*!
    Copyright (c) 2016 Jed Watson.
    Licensed under the MIT License (MIT), see
    http://jedwatson.github.io/classnames
  */
  /* global define */

  (function () {

  	var hasOwn = {}.hasOwnProperty;

  	function classNames () {
  		var classes = [];

  		for (var i = 0; i < arguments.length; i++) {
  			var arg = arguments[i];
  			if (!arg) continue;

  			var argType = typeof arg;

  			if (argType === 'string' || argType === 'number') {
  				classes.push(arg);
  			} else if (Array.isArray(arg)) {
  				classes.push(classNames.apply(null, arg));
  			} else if (argType === 'object') {
  				for (var key in arg) {
  					if (hasOwn.call(arg, key) && arg[key]) {
  						classes.push(key);
  					}
  				}
  			}
  		}

  		return classes.join(' ');
  	}

  	if (module.exports) {
  		module.exports = classNames;
  	} else if (typeof undefined === 'function' && typeof undefined.amd === 'object' && undefined.amd) {
  		// register as 'classnames', consistent with npm package name
  		undefined('classnames', [], function () {
  			return classNames;
  		});
  	} else {
  		window.classNames = classNames;
  	}
  }());
  });

  /**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   *
   * 
   */

  function makeEmptyFunction(arg) {
    return function () {
      return arg;
    };
  }

  /**
   * This function accepts and discards inputs; it has no side effects. This is
   * primarily useful idiomatically for overridable function endpoints which
   * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
   */
  var emptyFunction = function emptyFunction() {};

  emptyFunction.thatReturns = makeEmptyFunction;
  emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
  emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
  emptyFunction.thatReturnsNull = makeEmptyFunction(null);
  emptyFunction.thatReturnsThis = function () {
    return this;
  };
  emptyFunction.thatReturnsArgument = function (arg) {
    return arg;
  };

  var emptyFunction_1 = emptyFunction;

  /**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   *
   */

  /**
   * Use invariant() to assert state which your program assumes to be true.
   *
   * Provide sprintf-style format (only %s is supported) and arguments
   * to provide information about what broke and what you were
   * expecting.
   *
   * The invariant message will be stripped in production, but the invariant
   * will remain to ensure logic does not differ in production.
   */

  var validateFormat = function validateFormat(format) {};

  {
    validateFormat = function validateFormat(format) {
      if (format === undefined) {
        throw new Error('invariant requires an error message argument');
      }
    };
  }

  function invariant(condition, format, a, b, c, d, e, f) {
    validateFormat(format);

    if (!condition) {
      var error;
      if (format === undefined) {
        error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
      } else {
        var args = [a, b, c, d, e, f];
        var argIndex = 0;
        error = new Error(format.replace(/%s/g, function () {
          return args[argIndex++];
        }));
        error.name = 'Invariant Violation';
      }

      error.framesToPop = 1; // we don't care about invariant's own frame
      throw error;
    }
  }

  var invariant_1 = invariant;

  /**
   * Similar to invariant but only logs a warning if the condition is not met.
   * This can be used to log issues in development environments in critical
   * paths. Removing the logging code for production environments will keep the
   * same logic and follow the same code paths.
   */

  var warning = emptyFunction_1;

  {
    var printWarning = function printWarning(format) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      var argIndex = 0;
      var message = 'Warning: ' + format.replace(/%s/g, function () {
        return args[argIndex++];
      });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // --- Welcome to debugging React ---
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch (x) {}
    };

    warning = function warning(condition, format) {
      if (format === undefined) {
        throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
      }

      if (format.indexOf('Failed Composite propType: ') === 0) {
        return; // Ignore CompositeComponent proptype check.
      }

      if (!condition) {
        for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
          args[_key2 - 2] = arguments[_key2];
        }

        printWarning.apply(undefined, [format].concat(args));
      }
    };
  }

  var warning_1 = warning;

  /*
  object-assign
  (c) Sindre Sorhus
  @license MIT
  */
  /* eslint-disable no-unused-vars */
  var getOwnPropertySymbols = Object.getOwnPropertySymbols;
  var hasOwnProperty = Object.prototype.hasOwnProperty;
  var propIsEnumerable = Object.prototype.propertyIsEnumerable;

  function toObject(val) {
  	if (val === null || val === undefined) {
  		throw new TypeError('Object.assign cannot be called with null or undefined');
  	}

  	return Object(val);
  }

  function shouldUseNative() {
  	try {
  		if (!Object.assign) {
  			return false;
  		}

  		// Detect buggy property enumeration order in older V8 versions.

  		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
  		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
  		test1[5] = 'de';
  		if (Object.getOwnPropertyNames(test1)[0] === '5') {
  			return false;
  		}

  		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
  		var test2 = {};
  		for (var i = 0; i < 10; i++) {
  			test2['_' + String.fromCharCode(i)] = i;
  		}
  		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
  			return test2[n];
  		});
  		if (order2.join('') !== '0123456789') {
  			return false;
  		}

  		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
  		var test3 = {};
  		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
  			test3[letter] = letter;
  		});
  		if (Object.keys(Object.assign({}, test3)).join('') !==
  				'abcdefghijklmnopqrst') {
  			return false;
  		}

  		return true;
  	} catch (err) {
  		// We don't expect any of the above to throw, but better to be safe.
  		return false;
  	}
  }

  var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
  	var from;
  	var to = toObject(target);
  	var symbols;

  	for (var s = 1; s < arguments.length; s++) {
  		from = Object(arguments[s]);

  		for (var key in from) {
  			if (hasOwnProperty.call(from, key)) {
  				to[key] = from[key];
  			}
  		}

  		if (getOwnPropertySymbols) {
  			symbols = getOwnPropertySymbols(from);
  			for (var i = 0; i < symbols.length; i++) {
  				if (propIsEnumerable.call(from, symbols[i])) {
  					to[symbols[i]] = from[symbols[i]];
  				}
  			}
  		}
  	}

  	return to;
  };

  /**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */

  var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

  var ReactPropTypesSecret_1 = ReactPropTypesSecret;

  {
    var invariant$1 = invariant_1;
    var warning$1 = warning_1;
    var ReactPropTypesSecret$1 = ReactPropTypesSecret_1;
    var loggedTypeFailures = {};
  }

  /**
   * Assert that the values match with the type specs.
   * Error messages are memorized and will only be shown once.
   *
   * @param {object} typeSpecs Map of name to a ReactPropType
   * @param {object} values Runtime values that need to be type-checked
   * @param {string} location e.g. "prop", "context", "child context"
   * @param {string} componentName Name of the component for error messages.
   * @param {?Function} getStack Returns the component stack.
   * @private
   */
  function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
    {
      for (var typeSpecName in typeSpecs) {
        if (typeSpecs.hasOwnProperty(typeSpecName)) {
          var error;
          // Prop type validation may throw. In case they do, we don't want to
          // fail the render phase where it didn't fail before. So we log it.
          // After these have been cleaned up, we'll let them throw.
          try {
            // This is intentionally an invariant that gets caught. It's the same
            // behavior as without this statement except with a better message.
            invariant$1(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'the `prop-types` package, but received `%s`.', componentName || 'React class', location, typeSpecName, typeof typeSpecs[typeSpecName]);
            error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret$1);
          } catch (ex) {
            error = ex;
          }
          warning$1(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error);
          if (error instanceof Error && !(error.message in loggedTypeFailures)) {
            // Only monitor this failure once because there tends to be a lot of the
            // same error.
            loggedTypeFailures[error.message] = true;

            var stack = getStack ? getStack() : '';

            warning$1(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '');
          }
        }
      }
    }
  }

  var checkPropTypes_1 = checkPropTypes;

  var factoryWithTypeCheckers = function(isValidElement, throwOnDirectAccess) {
    /* global Symbol */
    var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

    /**
     * Returns the iterator method function contained on the iterable object.
     *
     * Be sure to invoke the function with the iterable as context:
     *
     *     var iteratorFn = getIteratorFn(myIterable);
     *     if (iteratorFn) {
     *       var iterator = iteratorFn.call(myIterable);
     *       ...
     *     }
     *
     * @param {?object} maybeIterable
     * @return {?function}
     */
    function getIteratorFn(maybeIterable) {
      var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
      if (typeof iteratorFn === 'function') {
        return iteratorFn;
      }
    }

    /**
     * Collection of methods that allow declaration and validation of props that are
     * supplied to React components. Example usage:
     *
     *   var Props = require('ReactPropTypes');
     *   var MyArticle = React.createClass({
     *     propTypes: {
     *       // An optional string prop named "description".
     *       description: Props.string,
     *
     *       // A required enum prop named "category".
     *       category: Props.oneOf(['News','Photos']).isRequired,
     *
     *       // A prop named "dialog" that requires an instance of Dialog.
     *       dialog: Props.instanceOf(Dialog).isRequired
     *     },
     *     render: function() { ... }
     *   });
     *
     * A more formal specification of how these methods are used:
     *
     *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
     *   decl := ReactPropTypes.{type}(.isRequired)?
     *
     * Each and every declaration produces a function with the same signature. This
     * allows the creation of custom validation functions. For example:
     *
     *  var MyLink = React.createClass({
     *    propTypes: {
     *      // An optional string or URI prop named "href".
     *      href: function(props, propName, componentName) {
     *        var propValue = props[propName];
     *        if (propValue != null && typeof propValue !== 'string' &&
     *            !(propValue instanceof URI)) {
     *          return new Error(
     *            'Expected a string or an URI for ' + propName + ' in ' +
     *            componentName
     *          );
     *        }
     *      }
     *    },
     *    render: function() {...}
     *  });
     *
     * @internal
     */

    var ANONYMOUS = '<<anonymous>>';

    // Important!
    // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
    var ReactPropTypes = {
      array: createPrimitiveTypeChecker('array'),
      bool: createPrimitiveTypeChecker('boolean'),
      func: createPrimitiveTypeChecker('function'),
      number: createPrimitiveTypeChecker('number'),
      object: createPrimitiveTypeChecker('object'),
      string: createPrimitiveTypeChecker('string'),
      symbol: createPrimitiveTypeChecker('symbol'),

      any: createAnyTypeChecker(),
      arrayOf: createArrayOfTypeChecker,
      element: createElementTypeChecker(),
      instanceOf: createInstanceTypeChecker,
      node: createNodeChecker(),
      objectOf: createObjectOfTypeChecker,
      oneOf: createEnumTypeChecker,
      oneOfType: createUnionTypeChecker,
      shape: createShapeTypeChecker,
      exact: createStrictShapeTypeChecker,
    };

    /**
     * inlined Object.is polyfill to avoid requiring consumers ship their own
     * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
     */
    /*eslint-disable no-self-compare*/
    function is(x, y) {
      // SameValue algorithm
      if (x === y) {
        // Steps 1-5, 7-10
        // Steps 6.b-6.e: +0 != -0
        return x !== 0 || 1 / x === 1 / y;
      } else {
        // Step 6.a: NaN == NaN
        return x !== x && y !== y;
      }
    }
    /*eslint-enable no-self-compare*/

    /**
     * We use an Error-like object for backward compatibility as people may call
     * PropTypes directly and inspect their output. However, we don't use real
     * Errors anymore. We don't inspect their stack anyway, and creating them
     * is prohibitively expensive if they are created too often, such as what
     * happens in oneOfType() for any type before the one that matched.
     */
    function PropTypeError(message) {
      this.message = message;
      this.stack = '';
    }
    // Make `instanceof Error` still work for returned errors.
    PropTypeError.prototype = Error.prototype;

    function createChainableTypeChecker(validate) {
      {
        var manualPropTypeCallCache = {};
        var manualPropTypeWarningCount = 0;
      }
      function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
        componentName = componentName || ANONYMOUS;
        propFullName = propFullName || propName;

        if (secret !== ReactPropTypesSecret_1) {
          if (throwOnDirectAccess) {
            // New behavior only for users of `prop-types` package
            invariant_1(
              false,
              'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
              'Use `PropTypes.checkPropTypes()` to call them. ' +
              'Read more at http://fb.me/use-check-prop-types'
            );
          } else if (typeof console !== 'undefined') {
            // Old behavior for people using React.PropTypes
            var cacheKey = componentName + ':' + propName;
            if (
              !manualPropTypeCallCache[cacheKey] &&
              // Avoid spamming the console because they are often not actionable except for lib authors
              manualPropTypeWarningCount < 3
            ) {
              warning_1(
                false,
                'You are manually calling a React.PropTypes validation ' +
                'function for the `%s` prop on `%s`. This is deprecated ' +
                'and will throw in the standalone `prop-types` package. ' +
                'You may be seeing this warning due to a third-party PropTypes ' +
                'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.',
                propFullName,
                componentName
              );
              manualPropTypeCallCache[cacheKey] = true;
              manualPropTypeWarningCount++;
            }
          }
        }
        if (props[propName] == null) {
          if (isRequired) {
            if (props[propName] === null) {
              return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
            }
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
          }
          return null;
        } else {
          return validate(props, propName, componentName, location, propFullName);
        }
      }

      var chainedCheckType = checkType.bind(null, false);
      chainedCheckType.isRequired = checkType.bind(null, true);

      return chainedCheckType;
    }

    function createPrimitiveTypeChecker(expectedType) {
      function validate(props, propName, componentName, location, propFullName, secret) {
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== expectedType) {
          // `propValue` being instance of, say, date/regexp, pass the 'object'
          // check, but we can offer a more precise error message here rather than
          // 'of type `object`'.
          var preciseType = getPreciseType(propValue);

          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }

    function createAnyTypeChecker() {
      return createChainableTypeChecker(emptyFunction_1.thatReturnsNull);
    }

    function createArrayOfTypeChecker(typeChecker) {
      function validate(props, propName, componentName, location, propFullName) {
        if (typeof typeChecker !== 'function') {
          return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
        }
        var propValue = props[propName];
        if (!Array.isArray(propValue)) {
          var propType = getPropType(propValue);
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
        }
        for (var i = 0; i < propValue.length; i++) {
          var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret_1);
          if (error instanceof Error) {
            return error;
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }

    function createElementTypeChecker() {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        if (!isValidElement(propValue)) {
          var propType = getPropType(propValue);
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }

    function createInstanceTypeChecker(expectedClass) {
      function validate(props, propName, componentName, location, propFullName) {
        if (!(props[propName] instanceof expectedClass)) {
          var expectedClassName = expectedClass.name || ANONYMOUS;
          var actualClassName = getClassName(props[propName]);
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }

    function createEnumTypeChecker(expectedValues) {
      if (!Array.isArray(expectedValues)) {
        warning_1(false, 'Invalid argument supplied to oneOf, expected an instance of array.');
        return emptyFunction_1.thatReturnsNull;
      }

      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        for (var i = 0; i < expectedValues.length; i++) {
          if (is(propValue, expectedValues[i])) {
            return null;
          }
        }

        var valuesString = JSON.stringify(expectedValues);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
      }
      return createChainableTypeChecker(validate);
    }

    function createObjectOfTypeChecker(typeChecker) {
      function validate(props, propName, componentName, location, propFullName) {
        if (typeof typeChecker !== 'function') {
          return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
        }
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== 'object') {
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
        }
        for (var key in propValue) {
          if (propValue.hasOwnProperty(key)) {
            var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
            if (error instanceof Error) {
              return error;
            }
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }

    function createUnionTypeChecker(arrayOfTypeCheckers) {
      if (!Array.isArray(arrayOfTypeCheckers)) {
        warning_1(false, 'Invalid argument supplied to oneOfType, expected an instance of array.');
        return emptyFunction_1.thatReturnsNull;
      }

      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        if (typeof checker !== 'function') {
          warning_1(
            false,
            'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
            'received %s at index %s.',
            getPostfixForTypeWarning(checker),
            i
          );
          return emptyFunction_1.thatReturnsNull;
        }
      }

      function validate(props, propName, componentName, location, propFullName) {
        for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
          var checker = arrayOfTypeCheckers[i];
          if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret_1) == null) {
            return null;
          }
        }

        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
      }
      return createChainableTypeChecker(validate);
    }

    function createNodeChecker() {
      function validate(props, propName, componentName, location, propFullName) {
        if (!isNode(props[propName])) {
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }

    function createShapeTypeChecker(shapeTypes) {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== 'object') {
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
        }
        for (var key in shapeTypes) {
          var checker = shapeTypes[key];
          if (!checker) {
            continue;
          }
          var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
          if (error) {
            return error;
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }

    function createStrictShapeTypeChecker(shapeTypes) {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== 'object') {
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
        }
        // We need to check all keys in case some are required but missing from
        // props.
        var allKeys = objectAssign({}, props[propName], shapeTypes);
        for (var key in allKeys) {
          var checker = shapeTypes[key];
          if (!checker) {
            return new PropTypeError(
              'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
              '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
              '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
            );
          }
          var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
          if (error) {
            return error;
          }
        }
        return null;
      }

      return createChainableTypeChecker(validate);
    }

    function isNode(propValue) {
      switch (typeof propValue) {
        case 'number':
        case 'string':
        case 'undefined':
          return true;
        case 'boolean':
          return !propValue;
        case 'object':
          if (Array.isArray(propValue)) {
            return propValue.every(isNode);
          }
          if (propValue === null || isValidElement(propValue)) {
            return true;
          }

          var iteratorFn = getIteratorFn(propValue);
          if (iteratorFn) {
            var iterator = iteratorFn.call(propValue);
            var step;
            if (iteratorFn !== propValue.entries) {
              while (!(step = iterator.next()).done) {
                if (!isNode(step.value)) {
                  return false;
                }
              }
            } else {
              // Iterator will provide entry [k,v] tuples rather than values.
              while (!(step = iterator.next()).done) {
                var entry = step.value;
                if (entry) {
                  if (!isNode(entry[1])) {
                    return false;
                  }
                }
              }
            }
          } else {
            return false;
          }

          return true;
        default:
          return false;
      }
    }

    function isSymbol(propType, propValue) {
      // Native Symbol.
      if (propType === 'symbol') {
        return true;
      }

      // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
      if (propValue['@@toStringTag'] === 'Symbol') {
        return true;
      }

      // Fallback for non-spec compliant Symbols which are polyfilled.
      if (typeof Symbol === 'function' && propValue instanceof Symbol) {
        return true;
      }

      return false;
    }

    // Equivalent of `typeof` but with special handling for array and regexp.
    function getPropType(propValue) {
      var propType = typeof propValue;
      if (Array.isArray(propValue)) {
        return 'array';
      }
      if (propValue instanceof RegExp) {
        // Old webkits (at least until Android 4.0) return 'function' rather than
        // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
        // passes PropTypes.object.
        return 'object';
      }
      if (isSymbol(propType, propValue)) {
        return 'symbol';
      }
      return propType;
    }

    // This handles more types than `getPropType`. Only used for error messages.
    // See `createPrimitiveTypeChecker`.
    function getPreciseType(propValue) {
      if (typeof propValue === 'undefined' || propValue === null) {
        return '' + propValue;
      }
      var propType = getPropType(propValue);
      if (propType === 'object') {
        if (propValue instanceof Date) {
          return 'date';
        } else if (propValue instanceof RegExp) {
          return 'regexp';
        }
      }
      return propType;
    }

    // Returns a string that is postfixed to a warning about an invalid type.
    // For example, "undefined" or "of type array"
    function getPostfixForTypeWarning(value) {
      var type = getPreciseType(value);
      switch (type) {
        case 'array':
        case 'object':
          return 'an ' + type;
        case 'boolean':
        case 'date':
        case 'regexp':
          return 'a ' + type;
        default:
          return type;
      }
    }

    // Returns class name of the object, if any.
    function getClassName(propValue) {
      if (!propValue.constructor || !propValue.constructor.name) {
        return ANONYMOUS;
      }
      return propValue.constructor.name;
    }

    ReactPropTypes.checkPropTypes = checkPropTypes_1;
    ReactPropTypes.PropTypes = ReactPropTypes;

    return ReactPropTypes;
  };

  var propTypes = createCommonjsModule(function (module) {
  /**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */

  {
    var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
      Symbol.for &&
      Symbol.for('react.element')) ||
      0xeac7;

    var isValidElement = function(object) {
      return typeof object === 'object' &&
        object !== null &&
        object.$$typeof === REACT_ELEMENT_TYPE;
    };

    // By explicitly using `prop-types` you are opting into new development behavior.
    // http://fb.me/prop-types-in-prod
    var throwOnDirectAccess = true;
    module.exports = factoryWithTypeCheckers(isValidElement, throwOnDirectAccess);
  }
  });

  function Bubble(props) {
    var position = props.position,
        offset = props.offset,
        children = props.children,
        className = props.className;
    var style = props.style;
    var offsetProperty = position === 'top' || position === 'bottom' ? 'top' : 'left';
    var positions = {
      top: 'bottom',
      bottom: 'top',
      left: 'right',
      right: 'left'
    };
    var typeCls = position == null ? '' : "tc-15-bubble-".concat(positions[position]);
    var realStype = {};

    if (offset) {
      realStype[offsetProperty] = offset;
    }

    realStype = Object.assign({}, style);
    return React.createElement("div", {
      className: classnames$1('tc-15-bubble', typeCls, className),
      style: realStype
    }, React.createElement("div", {
      className: "tc-15-bubble-inner"
    }, children));
  }
  Bubble.defaultProps = {
    position: 'top',
    offset: null
  };

  var hoistNonReactStatics = createCommonjsModule(function (module, exports) {
  /**
   * Copyright 2015, Yahoo! Inc.
   * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
   */
  (function (global, factory) {
      module.exports = factory();
  }(commonjsGlobal, (function () {
      
      var REACT_STATICS = {
          childContextTypes: true,
          contextTypes: true,
          defaultProps: true,
          displayName: true,
          getDefaultProps: true,
          getDerivedStateFromProps: true,
          mixins: true,
          propTypes: true,
          type: true
      };
      
      var KNOWN_STATICS = {
          name: true,
          length: true,
          prototype: true,
          caller: true,
          callee: true,
          arguments: true,
          arity: true
      };
      
      var defineProperty = Object.defineProperty;
      var getOwnPropertyNames = Object.getOwnPropertyNames;
      var getOwnPropertySymbols = Object.getOwnPropertySymbols;
      var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
      var getPrototypeOf = Object.getPrototypeOf;
      var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
      
      return function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
          if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
              
              if (objectPrototype) {
                  var inheritedComponent = getPrototypeOf(sourceComponent);
                  if (inheritedComponent && inheritedComponent !== objectPrototype) {
                      hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
                  }
              }
              
              var keys = getOwnPropertyNames(sourceComponent);
              
              if (getOwnPropertySymbols) {
                  keys = keys.concat(getOwnPropertySymbols(sourceComponent));
              }
              
              for (var i = 0; i < keys.length; ++i) {
                  var key = keys[i];
                  if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                      var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                      try { // Avoid failures from read-only properties
                          defineProperty(targetComponent, key, descriptor);
                      } catch (e) {}
                  }
              }
              
              return targetComponent;
          }
          
          return targetComponent;
      };
  })));
  });

  /**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   *
   * 
   */

  function makeEmptyFunction$1(arg) {
    return function () {
      return arg;
    };
  }

  /**
   * This function accepts and discards inputs; it has no side effects. This is
   * primarily useful idiomatically for overridable function endpoints which
   * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
   */
  var emptyFunction$1 = function emptyFunction() {};

  emptyFunction$1.thatReturns = makeEmptyFunction$1;
  emptyFunction$1.thatReturnsFalse = makeEmptyFunction$1(false);
  emptyFunction$1.thatReturnsTrue = makeEmptyFunction$1(true);
  emptyFunction$1.thatReturnsNull = makeEmptyFunction$1(null);
  emptyFunction$1.thatReturnsThis = function () {
    return this;
  };
  emptyFunction$1.thatReturnsArgument = function (arg) {
    return arg;
  };

  var emptyFunction_1$1 = emptyFunction$1;

  /**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   *
   */

  /**
   * Use invariant() to assert state which your program assumes to be true.
   *
   * Provide sprintf-style format (only %s is supported) and arguments
   * to provide information about what broke and what you were
   * expecting.
   *
   * The invariant message will be stripped in production, but the invariant
   * will remain to ensure logic does not differ in production.
   */

  var validateFormat$1 = function validateFormat(format) {};

  {
    validateFormat$1 = function validateFormat(format) {
      if (format === undefined) {
        throw new Error('invariant requires an error message argument');
      }
    };
  }

  function invariant$2(condition, format, a, b, c, d, e, f) {
    validateFormat$1(format);

    if (!condition) {
      var error;
      if (format === undefined) {
        error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
      } else {
        var args = [a, b, c, d, e, f];
        var argIndex = 0;
        error = new Error(format.replace(/%s/g, function () {
          return args[argIndex++];
        }));
        error.name = 'Invariant Violation';
      }

      error.framesToPop = 1; // we don't care about invariant's own frame
      throw error;
    }
  }

  var invariant_1$1 = invariant$2;

  /**
   * Similar to invariant but only logs a warning if the condition is not met.
   * This can be used to log issues in development environments in critical
   * paths. Removing the logging code for production environments will keep the
   * same logic and follow the same code paths.
   */

  var warning$2 = emptyFunction_1$1;

  {
    var printWarning$1 = function printWarning(format) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      var argIndex = 0;
      var message = 'Warning: ' + format.replace(/%s/g, function () {
        return args[argIndex++];
      });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // --- Welcome to debugging React ---
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch (x) {}
    };

    warning$2 = function warning(condition, format) {
      if (format === undefined) {
        throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
      }

      if (format.indexOf('Failed Composite propType: ') === 0) {
        return; // Ignore CompositeComponent proptype check.
      }

      if (!condition) {
        for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
          args[_key2 - 2] = arguments[_key2];
        }

        printWarning$1.apply(undefined, [format].concat(args));
      }
    };
  }

  var warning_1$1 = warning$2;

  /*
  object-assign
  (c) Sindre Sorhus
  @license MIT
  */
  /* eslint-disable no-unused-vars */
  var getOwnPropertySymbols$1 = Object.getOwnPropertySymbols;
  var hasOwnProperty$1 = Object.prototype.hasOwnProperty;
  var propIsEnumerable$1 = Object.prototype.propertyIsEnumerable;

  function toObject$1(val) {
  	if (val === null || val === undefined) {
  		throw new TypeError('Object.assign cannot be called with null or undefined');
  	}

  	return Object(val);
  }

  function shouldUseNative$1() {
  	try {
  		if (!Object.assign) {
  			return false;
  		}

  		// Detect buggy property enumeration order in older V8 versions.

  		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
  		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
  		test1[5] = 'de';
  		if (Object.getOwnPropertyNames(test1)[0] === '5') {
  			return false;
  		}

  		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
  		var test2 = {};
  		for (var i = 0; i < 10; i++) {
  			test2['_' + String.fromCharCode(i)] = i;
  		}
  		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
  			return test2[n];
  		});
  		if (order2.join('') !== '0123456789') {
  			return false;
  		}

  		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
  		var test3 = {};
  		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
  			test3[letter] = letter;
  		});
  		if (Object.keys(Object.assign({}, test3)).join('') !==
  				'abcdefghijklmnopqrst') {
  			return false;
  		}

  		return true;
  	} catch (err) {
  		// We don't expect any of the above to throw, but better to be safe.
  		return false;
  	}
  }

  var objectAssign$1 = shouldUseNative$1() ? Object.assign : function (target, source) {
  	var from;
  	var to = toObject$1(target);
  	var symbols;

  	for (var s = 1; s < arguments.length; s++) {
  		from = Object(arguments[s]);

  		for (var key in from) {
  			if (hasOwnProperty$1.call(from, key)) {
  				to[key] = from[key];
  			}
  		}

  		if (getOwnPropertySymbols$1) {
  			symbols = getOwnPropertySymbols$1(from);
  			for (var i = 0; i < symbols.length; i++) {
  				if (propIsEnumerable$1.call(from, symbols[i])) {
  					to[symbols[i]] = from[symbols[i]];
  				}
  			}
  		}
  	}

  	return to;
  };

  /**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */

  var ReactPropTypesSecret$2 = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

  var ReactPropTypesSecret_1$1 = ReactPropTypesSecret$2;

  {
    var invariant$3 = invariant_1$1;
    var warning$3 = warning_1$1;
    var ReactPropTypesSecret$3 = ReactPropTypesSecret_1$1;
    var loggedTypeFailures$1 = {};
  }

  /**
   * Assert that the values match with the type specs.
   * Error messages are memorized and will only be shown once.
   *
   * @param {object} typeSpecs Map of name to a ReactPropType
   * @param {object} values Runtime values that need to be type-checked
   * @param {string} location e.g. "prop", "context", "child context"
   * @param {string} componentName Name of the component for error messages.
   * @param {?Function} getStack Returns the component stack.
   * @private
   */
  function checkPropTypes$1(typeSpecs, values, location, componentName, getStack) {
    {
      for (var typeSpecName in typeSpecs) {
        if (typeSpecs.hasOwnProperty(typeSpecName)) {
          var error;
          // Prop type validation may throw. In case they do, we don't want to
          // fail the render phase where it didn't fail before. So we log it.
          // After these have been cleaned up, we'll let them throw.
          try {
            // This is intentionally an invariant that gets caught. It's the same
            // behavior as without this statement except with a better message.
            invariant$3(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'the `prop-types` package, but received `%s`.', componentName || 'React class', location, typeSpecName, typeof typeSpecs[typeSpecName]);
            error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret$3);
          } catch (ex) {
            error = ex;
          }
          warning$3(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error);
          if (error instanceof Error && !(error.message in loggedTypeFailures$1)) {
            // Only monitor this failure once because there tends to be a lot of the
            // same error.
            loggedTypeFailures$1[error.message] = true;

            var stack = getStack ? getStack() : '';

            warning$3(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '');
          }
        }
      }
    }
  }

  var checkPropTypes_1$1 = checkPropTypes$1;

  var factoryWithTypeCheckers$1 = function(isValidElement, throwOnDirectAccess) {
    /* global Symbol */
    var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

    /**
     * Returns the iterator method function contained on the iterable object.
     *
     * Be sure to invoke the function with the iterable as context:
     *
     *     var iteratorFn = getIteratorFn(myIterable);
     *     if (iteratorFn) {
     *       var iterator = iteratorFn.call(myIterable);
     *       ...
     *     }
     *
     * @param {?object} maybeIterable
     * @return {?function}
     */
    function getIteratorFn(maybeIterable) {
      var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
      if (typeof iteratorFn === 'function') {
        return iteratorFn;
      }
    }

    /**
     * Collection of methods that allow declaration and validation of props that are
     * supplied to React components. Example usage:
     *
     *   var Props = require('ReactPropTypes');
     *   var MyArticle = React.createClass({
     *     propTypes: {
     *       // An optional string prop named "description".
     *       description: Props.string,
     *
     *       // A required enum prop named "category".
     *       category: Props.oneOf(['News','Photos']).isRequired,
     *
     *       // A prop named "dialog" that requires an instance of Dialog.
     *       dialog: Props.instanceOf(Dialog).isRequired
     *     },
     *     render: function() { ... }
     *   });
     *
     * A more formal specification of how these methods are used:
     *
     *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
     *   decl := ReactPropTypes.{type}(.isRequired)?
     *
     * Each and every declaration produces a function with the same signature. This
     * allows the creation of custom validation functions. For example:
     *
     *  var MyLink = React.createClass({
     *    propTypes: {
     *      // An optional string or URI prop named "href".
     *      href: function(props, propName, componentName) {
     *        var propValue = props[propName];
     *        if (propValue != null && typeof propValue !== 'string' &&
     *            !(propValue instanceof URI)) {
     *          return new Error(
     *            'Expected a string or an URI for ' + propName + ' in ' +
     *            componentName
     *          );
     *        }
     *      }
     *    },
     *    render: function() {...}
     *  });
     *
     * @internal
     */

    var ANONYMOUS = '<<anonymous>>';

    // Important!
    // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
    var ReactPropTypes = {
      array: createPrimitiveTypeChecker('array'),
      bool: createPrimitiveTypeChecker('boolean'),
      func: createPrimitiveTypeChecker('function'),
      number: createPrimitiveTypeChecker('number'),
      object: createPrimitiveTypeChecker('object'),
      string: createPrimitiveTypeChecker('string'),
      symbol: createPrimitiveTypeChecker('symbol'),

      any: createAnyTypeChecker(),
      arrayOf: createArrayOfTypeChecker,
      element: createElementTypeChecker(),
      instanceOf: createInstanceTypeChecker,
      node: createNodeChecker(),
      objectOf: createObjectOfTypeChecker,
      oneOf: createEnumTypeChecker,
      oneOfType: createUnionTypeChecker,
      shape: createShapeTypeChecker,
      exact: createStrictShapeTypeChecker,
    };

    /**
     * inlined Object.is polyfill to avoid requiring consumers ship their own
     * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
     */
    /*eslint-disable no-self-compare*/
    function is(x, y) {
      // SameValue algorithm
      if (x === y) {
        // Steps 1-5, 7-10
        // Steps 6.b-6.e: +0 != -0
        return x !== 0 || 1 / x === 1 / y;
      } else {
        // Step 6.a: NaN == NaN
        return x !== x && y !== y;
      }
    }
    /*eslint-enable no-self-compare*/

    /**
     * We use an Error-like object for backward compatibility as people may call
     * PropTypes directly and inspect their output. However, we don't use real
     * Errors anymore. We don't inspect their stack anyway, and creating them
     * is prohibitively expensive if they are created too often, such as what
     * happens in oneOfType() for any type before the one that matched.
     */
    function PropTypeError(message) {
      this.message = message;
      this.stack = '';
    }
    // Make `instanceof Error` still work for returned errors.
    PropTypeError.prototype = Error.prototype;

    function createChainableTypeChecker(validate) {
      {
        var manualPropTypeCallCache = {};
        var manualPropTypeWarningCount = 0;
      }
      function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
        componentName = componentName || ANONYMOUS;
        propFullName = propFullName || propName;

        if (secret !== ReactPropTypesSecret_1$1) {
          if (throwOnDirectAccess) {
            // New behavior only for users of `prop-types` package
            invariant_1$1(
              false,
              'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
              'Use `PropTypes.checkPropTypes()` to call them. ' +
              'Read more at http://fb.me/use-check-prop-types'
            );
          } else if (typeof console !== 'undefined') {
            // Old behavior for people using React.PropTypes
            var cacheKey = componentName + ':' + propName;
            if (
              !manualPropTypeCallCache[cacheKey] &&
              // Avoid spamming the console because they are often not actionable except for lib authors
              manualPropTypeWarningCount < 3
            ) {
              warning_1$1(
                false,
                'You are manually calling a React.PropTypes validation ' +
                'function for the `%s` prop on `%s`. This is deprecated ' +
                'and will throw in the standalone `prop-types` package. ' +
                'You may be seeing this warning due to a third-party PropTypes ' +
                'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.',
                propFullName,
                componentName
              );
              manualPropTypeCallCache[cacheKey] = true;
              manualPropTypeWarningCount++;
            }
          }
        }
        if (props[propName] == null) {
          if (isRequired) {
            if (props[propName] === null) {
              return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
            }
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
          }
          return null;
        } else {
          return validate(props, propName, componentName, location, propFullName);
        }
      }

      var chainedCheckType = checkType.bind(null, false);
      chainedCheckType.isRequired = checkType.bind(null, true);

      return chainedCheckType;
    }

    function createPrimitiveTypeChecker(expectedType) {
      function validate(props, propName, componentName, location, propFullName, secret) {
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== expectedType) {
          // `propValue` being instance of, say, date/regexp, pass the 'object'
          // check, but we can offer a more precise error message here rather than
          // 'of type `object`'.
          var preciseType = getPreciseType(propValue);

          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }

    function createAnyTypeChecker() {
      return createChainableTypeChecker(emptyFunction_1$1.thatReturnsNull);
    }

    function createArrayOfTypeChecker(typeChecker) {
      function validate(props, propName, componentName, location, propFullName) {
        if (typeof typeChecker !== 'function') {
          return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
        }
        var propValue = props[propName];
        if (!Array.isArray(propValue)) {
          var propType = getPropType(propValue);
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
        }
        for (var i = 0; i < propValue.length; i++) {
          var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret_1$1);
          if (error instanceof Error) {
            return error;
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }

    function createElementTypeChecker() {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        if (!isValidElement(propValue)) {
          var propType = getPropType(propValue);
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }

    function createInstanceTypeChecker(expectedClass) {
      function validate(props, propName, componentName, location, propFullName) {
        if (!(props[propName] instanceof expectedClass)) {
          var expectedClassName = expectedClass.name || ANONYMOUS;
          var actualClassName = getClassName(props[propName]);
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }

    function createEnumTypeChecker(expectedValues) {
      if (!Array.isArray(expectedValues)) {
        warning_1$1(false, 'Invalid argument supplied to oneOf, expected an instance of array.');
        return emptyFunction_1$1.thatReturnsNull;
      }

      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        for (var i = 0; i < expectedValues.length; i++) {
          if (is(propValue, expectedValues[i])) {
            return null;
          }
        }

        var valuesString = JSON.stringify(expectedValues);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
      }
      return createChainableTypeChecker(validate);
    }

    function createObjectOfTypeChecker(typeChecker) {
      function validate(props, propName, componentName, location, propFullName) {
        if (typeof typeChecker !== 'function') {
          return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
        }
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== 'object') {
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
        }
        for (var key in propValue) {
          if (propValue.hasOwnProperty(key)) {
            var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1$1);
            if (error instanceof Error) {
              return error;
            }
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }

    function createUnionTypeChecker(arrayOfTypeCheckers) {
      if (!Array.isArray(arrayOfTypeCheckers)) {
        warning_1$1(false, 'Invalid argument supplied to oneOfType, expected an instance of array.');
        return emptyFunction_1$1.thatReturnsNull;
      }

      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        if (typeof checker !== 'function') {
          warning_1$1(
            false,
            'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
            'received %s at index %s.',
            getPostfixForTypeWarning(checker),
            i
          );
          return emptyFunction_1$1.thatReturnsNull;
        }
      }

      function validate(props, propName, componentName, location, propFullName) {
        for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
          var checker = arrayOfTypeCheckers[i];
          if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret_1$1) == null) {
            return null;
          }
        }

        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
      }
      return createChainableTypeChecker(validate);
    }

    function createNodeChecker() {
      function validate(props, propName, componentName, location, propFullName) {
        if (!isNode(props[propName])) {
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }

    function createShapeTypeChecker(shapeTypes) {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== 'object') {
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
        }
        for (var key in shapeTypes) {
          var checker = shapeTypes[key];
          if (!checker) {
            continue;
          }
          var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1$1);
          if (error) {
            return error;
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }

    function createStrictShapeTypeChecker(shapeTypes) {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== 'object') {
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
        }
        // We need to check all keys in case some are required but missing from
        // props.
        var allKeys = objectAssign$1({}, props[propName], shapeTypes);
        for (var key in allKeys) {
          var checker = shapeTypes[key];
          if (!checker) {
            return new PropTypeError(
              'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
              '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
              '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
            );
          }
          var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1$1);
          if (error) {
            return error;
          }
        }
        return null;
      }

      return createChainableTypeChecker(validate);
    }

    function isNode(propValue) {
      switch (typeof propValue) {
        case 'number':
        case 'string':
        case 'undefined':
          return true;
        case 'boolean':
          return !propValue;
        case 'object':
          if (Array.isArray(propValue)) {
            return propValue.every(isNode);
          }
          if (propValue === null || isValidElement(propValue)) {
            return true;
          }

          var iteratorFn = getIteratorFn(propValue);
          if (iteratorFn) {
            var iterator = iteratorFn.call(propValue);
            var step;
            if (iteratorFn !== propValue.entries) {
              while (!(step = iterator.next()).done) {
                if (!isNode(step.value)) {
                  return false;
                }
              }
            } else {
              // Iterator will provide entry [k,v] tuples rather than values.
              while (!(step = iterator.next()).done) {
                var entry = step.value;
                if (entry) {
                  if (!isNode(entry[1])) {
                    return false;
                  }
                }
              }
            }
          } else {
            return false;
          }

          return true;
        default:
          return false;
      }
    }

    function isSymbol(propType, propValue) {
      // Native Symbol.
      if (propType === 'symbol') {
        return true;
      }

      // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
      if (propValue['@@toStringTag'] === 'Symbol') {
        return true;
      }

      // Fallback for non-spec compliant Symbols which are polyfilled.
      if (typeof Symbol === 'function' && propValue instanceof Symbol) {
        return true;
      }

      return false;
    }

    // Equivalent of `typeof` but with special handling for array and regexp.
    function getPropType(propValue) {
      var propType = typeof propValue;
      if (Array.isArray(propValue)) {
        return 'array';
      }
      if (propValue instanceof RegExp) {
        // Old webkits (at least until Android 4.0) return 'function' rather than
        // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
        // passes PropTypes.object.
        return 'object';
      }
      if (isSymbol(propType, propValue)) {
        return 'symbol';
      }
      return propType;
    }

    // This handles more types than `getPropType`. Only used for error messages.
    // See `createPrimitiveTypeChecker`.
    function getPreciseType(propValue) {
      if (typeof propValue === 'undefined' || propValue === null) {
        return '' + propValue;
      }
      var propType = getPropType(propValue);
      if (propType === 'object') {
        if (propValue instanceof Date) {
          return 'date';
        } else if (propValue instanceof RegExp) {
          return 'regexp';
        }
      }
      return propType;
    }

    // Returns a string that is postfixed to a warning about an invalid type.
    // For example, "undefined" or "of type array"
    function getPostfixForTypeWarning(value) {
      var type = getPreciseType(value);
      switch (type) {
        case 'array':
        case 'object':
          return 'an ' + type;
        case 'boolean':
        case 'date':
        case 'regexp':
          return 'a ' + type;
        default:
          return type;
      }
    }

    // Returns class name of the object, if any.
    function getClassName(propValue) {
      if (!propValue.constructor || !propValue.constructor.name) {
        return ANONYMOUS;
      }
      return propValue.constructor.name;
    }

    ReactPropTypes.checkPropTypes = checkPropTypes_1$1;
    ReactPropTypes.PropTypes = ReactPropTypes;

    return ReactPropTypes;
  };

  var propTypes$1 = createCommonjsModule(function (module) {
  /**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */

  {
    var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
      Symbol.for &&
      Symbol.for('react.element')) ||
      0xeac7;

    var isValidElement = function(object) {
      return typeof object === 'object' &&
        object !== null &&
        object.$$typeof === REACT_ELEMENT_TYPE;
    };

    // By explicitly using `prop-types` you are opting into new development behavior.
    // http://fb.me/prop-types-in-prod
    var throwOnDirectAccess = true;
    module.exports = factoryWithTypeCheckers$1(isValidElement, throwOnDirectAccess);
  }
  });

  function _typeof$1(obj) {
    if (typeof Symbol === "function" && _typeof(Symbol.iterator) === "symbol") {
      _typeof$1 = function _typeof$$1(obj) {
        return _typeof(obj);
      };
    } else {
      _typeof$1 = function _typeof$$1(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof(obj);
      };
    }

    return _typeof$1(obj);
  }

  function _extends$1() {
    _extends$1 = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends$1.apply(this, arguments);
  }

  function _objectWithoutProperties$2(source, excluded) {
    if (source == null) return {};

    var target = _objectWithoutPropertiesLoose$2(source, excluded);

    var key, i;

    if (Object.getOwnPropertySymbols) {
      var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

      for (i = 0; i < sourceSymbolKeys.length; i++) {
        key = sourceSymbolKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
      }
    }

    return target;
  }

  function _objectWithoutPropertiesLoose$2(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;

    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }

    return target;
  }

  function _classCallCheck$1(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _defineProperties$1(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass$1(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties$1(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties$1(Constructor, staticProps);
    return Constructor;
  }

  function _possibleConstructorReturn$1(self, call) {
    if (call && (_typeof$1(call) === "object" || typeof call === "function")) {
      return call;
    }

    return _assertThisInitialized$1(self);
  }

  function _getPrototypeOf$1(o) {
    _getPrototypeOf$1 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf$$1(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf$1(o);
  }

  function _inherits$1(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    if (superClass) _setPrototypeOf$1(subClass, superClass);
  }

  function _setPrototypeOf$1(o, p) {
    _setPrototypeOf$1 = Object.setPrototypeOf || function _setPrototypeOf$$1(o, p) {
      o.__proto__ = p;
      return o;
    };

    return _setPrototypeOf$1(o, p);
  }

  function _assertThisInitialized$1(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return self;
  }

  function _defineProperty$2(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }
  function enhanceWithClickOutside(WrappedComponent) {
    var componentName = WrappedComponent.displayName || WrappedComponent.name;

    var EnhancedComponent =
    /*#__PURE__*/
    function (_React$Component) {
      _inherits$1(EnhancedComponent, _React$Component);

      function EnhancedComponent() {
        var _getPrototypeOf2;

        var _this;

        _classCallCheck$1(this, EnhancedComponent);

        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        _this = _possibleConstructorReturn$1(this, (_getPrototypeOf2 = _getPrototypeOf$1(EnhancedComponent)).call.apply(_getPrototypeOf2, [this].concat(args)));

        _defineProperty$2(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "handleClickOutside", function (e) {
          var domNode = _this.__domNode;

          if ((!domNode || !domNode.contains(e.target)) && typeof _this.__wrappedInstance.handleClickOutside === 'function') {
            _this.__wrappedInstance.handleClickOutside(e);
          }
        });

        return _this;
      }

      _createClass$1(EnhancedComponent, [{
        key: "componentDidMount",
        value: function componentDidMount() {
          document.addEventListener('click', this.handleClickOutside, true);
        }
      }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          document.removeEventListener('click', this.handleClickOutside, true);
        }
      }, {
        key: "render",
        value: function render() {
          var _this2 = this;

          var _this$props = this.props,
              wrappedRef = _this$props.wrappedRef,
              rest = _objectWithoutProperties$2(_this$props, ["wrappedRef"]);

          return React.createElement(WrappedComponent, _extends$1({}, rest, {
            ref: function ref(c) {
              _this2.__wrappedInstance = c;
              _this2.__domNode = ReactDOM.findDOMNode(c);
              wrappedRef && wrappedRef(c);
            }
          }));
        }
      }]);

      return EnhancedComponent;
    }(React.Component);

    EnhancedComponent.displayName = "clickOutside(".concat(componentName, ")");
    return hoistNonReactStatics(EnhancedComponent, WrappedComponent);
  }

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   *
   * 
   */

  function makeEmptyFunction$2(arg) {
    return function () {
      return arg;
    };
  }

  /**
   * This function accepts and discards inputs; it has no side effects. This is
   * primarily useful idiomatically for overridable function endpoints which
   * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
   */
  var emptyFunction$2 = function emptyFunction() {};

  emptyFunction$2.thatReturns = makeEmptyFunction$2;
  emptyFunction$2.thatReturnsFalse = makeEmptyFunction$2(false);
  emptyFunction$2.thatReturnsTrue = makeEmptyFunction$2(true);
  emptyFunction$2.thatReturnsNull = makeEmptyFunction$2(null);
  emptyFunction$2.thatReturnsThis = function () {
    return this;
  };
  emptyFunction$2.thatReturnsArgument = function (arg) {
    return arg;
  };

  var emptyFunction_1$2 = emptyFunction$2;

  /**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   *
   */

  /**
   * Use invariant() to assert state which your program assumes to be true.
   *
   * Provide sprintf-style format (only %s is supported) and arguments
   * to provide information about what broke and what you were
   * expecting.
   *
   * The invariant message will be stripped in production, but the invariant
   * will remain to ensure logic does not differ in production.
   */

  var validateFormat$2 = function validateFormat(format) {};

  {
    validateFormat$2 = function validateFormat(format) {
      if (format === undefined) {
        throw new Error('invariant requires an error message argument');
      }
    };
  }

  function invariant$4(condition, format, a, b, c, d, e, f) {
    validateFormat$2(format);

    if (!condition) {
      var error;
      if (format === undefined) {
        error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
      } else {
        var args = [a, b, c, d, e, f];
        var argIndex = 0;
        error = new Error(format.replace(/%s/g, function () {
          return args[argIndex++];
        }));
        error.name = 'Invariant Violation';
      }

      error.framesToPop = 1; // we don't care about invariant's own frame
      throw error;
    }
  }

  var invariant_1$2 = invariant$4;

  /**
   * Similar to invariant but only logs a warning if the condition is not met.
   * This can be used to log issues in development environments in critical
   * paths. Removing the logging code for production environments will keep the
   * same logic and follow the same code paths.
   */

  var warning$4 = emptyFunction_1$2;

  {
    var printWarning$2 = function printWarning(format) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      var argIndex = 0;
      var message = 'Warning: ' + format.replace(/%s/g, function () {
        return args[argIndex++];
      });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // --- Welcome to debugging React ---
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch (x) {}
    };

    warning$4 = function warning(condition, format) {
      if (format === undefined) {
        throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
      }

      if (format.indexOf('Failed Composite propType: ') === 0) {
        return; // Ignore CompositeComponent proptype check.
      }

      if (!condition) {
        for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
          args[_key2 - 2] = arguments[_key2];
        }

        printWarning$2.apply(undefined, [format].concat(args));
      }
    };
  }

  var warning_1$2 = warning$4;

  /*
  object-assign
  (c) Sindre Sorhus
  @license MIT
  */
  /* eslint-disable no-unused-vars */
  var getOwnPropertySymbols$2 = Object.getOwnPropertySymbols;
  var hasOwnProperty$2 = Object.prototype.hasOwnProperty;
  var propIsEnumerable$2 = Object.prototype.propertyIsEnumerable;

  function toObject$2(val) {
  	if (val === null || val === undefined) {
  		throw new TypeError('Object.assign cannot be called with null or undefined');
  	}

  	return Object(val);
  }

  function shouldUseNative$2() {
  	try {
  		if (!Object.assign) {
  			return false;
  		}

  		// Detect buggy property enumeration order in older V8 versions.

  		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
  		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
  		test1[5] = 'de';
  		if (Object.getOwnPropertyNames(test1)[0] === '5') {
  			return false;
  		}

  		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
  		var test2 = {};
  		for (var i = 0; i < 10; i++) {
  			test2['_' + String.fromCharCode(i)] = i;
  		}
  		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
  			return test2[n];
  		});
  		if (order2.join('') !== '0123456789') {
  			return false;
  		}

  		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
  		var test3 = {};
  		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
  			test3[letter] = letter;
  		});
  		if (Object.keys(Object.assign({}, test3)).join('') !==
  				'abcdefghijklmnopqrst') {
  			return false;
  		}

  		return true;
  	} catch (err) {
  		// We don't expect any of the above to throw, but better to be safe.
  		return false;
  	}
  }

  var objectAssign$2 = shouldUseNative$2() ? Object.assign : function (target, source) {
  	var from;
  	var to = toObject$2(target);
  	var symbols;

  	for (var s = 1; s < arguments.length; s++) {
  		from = Object(arguments[s]);

  		for (var key in from) {
  			if (hasOwnProperty$2.call(from, key)) {
  				to[key] = from[key];
  			}
  		}

  		if (getOwnPropertySymbols$2) {
  			symbols = getOwnPropertySymbols$2(from);
  			for (var i = 0; i < symbols.length; i++) {
  				if (propIsEnumerable$2.call(from, symbols[i])) {
  					to[symbols[i]] = from[symbols[i]];
  				}
  			}
  		}
  	}

  	return to;
  };

  /**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */

  var ReactPropTypesSecret$4 = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

  var ReactPropTypesSecret_1$2 = ReactPropTypesSecret$4;

  {
    var invariant$5 = invariant_1$2;
    var warning$5 = warning_1$2;
    var ReactPropTypesSecret$5 = ReactPropTypesSecret_1$2;
    var loggedTypeFailures$2 = {};
  }

  /**
   * Assert that the values match with the type specs.
   * Error messages are memorized and will only be shown once.
   *
   * @param {object} typeSpecs Map of name to a ReactPropType
   * @param {object} values Runtime values that need to be type-checked
   * @param {string} location e.g. "prop", "context", "child context"
   * @param {string} componentName Name of the component for error messages.
   * @param {?Function} getStack Returns the component stack.
   * @private
   */
  function checkPropTypes$2(typeSpecs, values, location, componentName, getStack) {
    {
      for (var typeSpecName in typeSpecs) {
        if (typeSpecs.hasOwnProperty(typeSpecName)) {
          var error;
          // Prop type validation may throw. In case they do, we don't want to
          // fail the render phase where it didn't fail before. So we log it.
          // After these have been cleaned up, we'll let them throw.
          try {
            // This is intentionally an invariant that gets caught. It's the same
            // behavior as without this statement except with a better message.
            invariant$5(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'the `prop-types` package, but received `%s`.', componentName || 'React class', location, typeSpecName, typeof typeSpecs[typeSpecName]);
            error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret$5);
          } catch (ex) {
            error = ex;
          }
          warning$5(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error);
          if (error instanceof Error && !(error.message in loggedTypeFailures$2)) {
            // Only monitor this failure once because there tends to be a lot of the
            // same error.
            loggedTypeFailures$2[error.message] = true;

            var stack = getStack ? getStack() : '';

            warning$5(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '');
          }
        }
      }
    }
  }

  var checkPropTypes_1$2 = checkPropTypes$2;

  var factoryWithTypeCheckers$2 = function(isValidElement, throwOnDirectAccess) {
    /* global Symbol */
    var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

    /**
     * Returns the iterator method function contained on the iterable object.
     *
     * Be sure to invoke the function with the iterable as context:
     *
     *     var iteratorFn = getIteratorFn(myIterable);
     *     if (iteratorFn) {
     *       var iterator = iteratorFn.call(myIterable);
     *       ...
     *     }
     *
     * @param {?object} maybeIterable
     * @return {?function}
     */
    function getIteratorFn(maybeIterable) {
      var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
      if (typeof iteratorFn === 'function') {
        return iteratorFn;
      }
    }

    /**
     * Collection of methods that allow declaration and validation of props that are
     * supplied to React components. Example usage:
     *
     *   var Props = require('ReactPropTypes');
     *   var MyArticle = React.createClass({
     *     propTypes: {
     *       // An optional string prop named "description".
     *       description: Props.string,
     *
     *       // A required enum prop named "category".
     *       category: Props.oneOf(['News','Photos']).isRequired,
     *
     *       // A prop named "dialog" that requires an instance of Dialog.
     *       dialog: Props.instanceOf(Dialog).isRequired
     *     },
     *     render: function() { ... }
     *   });
     *
     * A more formal specification of how these methods are used:
     *
     *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
     *   decl := ReactPropTypes.{type}(.isRequired)?
     *
     * Each and every declaration produces a function with the same signature. This
     * allows the creation of custom validation functions. For example:
     *
     *  var MyLink = React.createClass({
     *    propTypes: {
     *      // An optional string or URI prop named "href".
     *      href: function(props, propName, componentName) {
     *        var propValue = props[propName];
     *        if (propValue != null && typeof propValue !== 'string' &&
     *            !(propValue instanceof URI)) {
     *          return new Error(
     *            'Expected a string or an URI for ' + propName + ' in ' +
     *            componentName
     *          );
     *        }
     *      }
     *    },
     *    render: function() {...}
     *  });
     *
     * @internal
     */

    var ANONYMOUS = '<<anonymous>>';

    // Important!
    // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
    var ReactPropTypes = {
      array: createPrimitiveTypeChecker('array'),
      bool: createPrimitiveTypeChecker('boolean'),
      func: createPrimitiveTypeChecker('function'),
      number: createPrimitiveTypeChecker('number'),
      object: createPrimitiveTypeChecker('object'),
      string: createPrimitiveTypeChecker('string'),
      symbol: createPrimitiveTypeChecker('symbol'),

      any: createAnyTypeChecker(),
      arrayOf: createArrayOfTypeChecker,
      element: createElementTypeChecker(),
      instanceOf: createInstanceTypeChecker,
      node: createNodeChecker(),
      objectOf: createObjectOfTypeChecker,
      oneOf: createEnumTypeChecker,
      oneOfType: createUnionTypeChecker,
      shape: createShapeTypeChecker,
      exact: createStrictShapeTypeChecker,
    };

    /**
     * inlined Object.is polyfill to avoid requiring consumers ship their own
     * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
     */
    /*eslint-disable no-self-compare*/
    function is(x, y) {
      // SameValue algorithm
      if (x === y) {
        // Steps 1-5, 7-10
        // Steps 6.b-6.e: +0 != -0
        return x !== 0 || 1 / x === 1 / y;
      } else {
        // Step 6.a: NaN == NaN
        return x !== x && y !== y;
      }
    }
    /*eslint-enable no-self-compare*/

    /**
     * We use an Error-like object for backward compatibility as people may call
     * PropTypes directly and inspect their output. However, we don't use real
     * Errors anymore. We don't inspect their stack anyway, and creating them
     * is prohibitively expensive if they are created too often, such as what
     * happens in oneOfType() for any type before the one that matched.
     */
    function PropTypeError(message) {
      this.message = message;
      this.stack = '';
    }
    // Make `instanceof Error` still work for returned errors.
    PropTypeError.prototype = Error.prototype;

    function createChainableTypeChecker(validate) {
      {
        var manualPropTypeCallCache = {};
        var manualPropTypeWarningCount = 0;
      }
      function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
        componentName = componentName || ANONYMOUS;
        propFullName = propFullName || propName;

        if (secret !== ReactPropTypesSecret_1$2) {
          if (throwOnDirectAccess) {
            // New behavior only for users of `prop-types` package
            invariant_1$2(
              false,
              'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
              'Use `PropTypes.checkPropTypes()` to call them. ' +
              'Read more at http://fb.me/use-check-prop-types'
            );
          } else if (typeof console !== 'undefined') {
            // Old behavior for people using React.PropTypes
            var cacheKey = componentName + ':' + propName;
            if (
              !manualPropTypeCallCache[cacheKey] &&
              // Avoid spamming the console because they are often not actionable except for lib authors
              manualPropTypeWarningCount < 3
            ) {
              warning_1$2(
                false,
                'You are manually calling a React.PropTypes validation ' +
                'function for the `%s` prop on `%s`. This is deprecated ' +
                'and will throw in the standalone `prop-types` package. ' +
                'You may be seeing this warning due to a third-party PropTypes ' +
                'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.',
                propFullName,
                componentName
              );
              manualPropTypeCallCache[cacheKey] = true;
              manualPropTypeWarningCount++;
            }
          }
        }
        if (props[propName] == null) {
          if (isRequired) {
            if (props[propName] === null) {
              return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
            }
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
          }
          return null;
        } else {
          return validate(props, propName, componentName, location, propFullName);
        }
      }

      var chainedCheckType = checkType.bind(null, false);
      chainedCheckType.isRequired = checkType.bind(null, true);

      return chainedCheckType;
    }

    function createPrimitiveTypeChecker(expectedType) {
      function validate(props, propName, componentName, location, propFullName, secret) {
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== expectedType) {
          // `propValue` being instance of, say, date/regexp, pass the 'object'
          // check, but we can offer a more precise error message here rather than
          // 'of type `object`'.
          var preciseType = getPreciseType(propValue);

          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }

    function createAnyTypeChecker() {
      return createChainableTypeChecker(emptyFunction_1$2.thatReturnsNull);
    }

    function createArrayOfTypeChecker(typeChecker) {
      function validate(props, propName, componentName, location, propFullName) {
        if (typeof typeChecker !== 'function') {
          return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
        }
        var propValue = props[propName];
        if (!Array.isArray(propValue)) {
          var propType = getPropType(propValue);
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
        }
        for (var i = 0; i < propValue.length; i++) {
          var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret_1$2);
          if (error instanceof Error) {
            return error;
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }

    function createElementTypeChecker() {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        if (!isValidElement(propValue)) {
          var propType = getPropType(propValue);
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }

    function createInstanceTypeChecker(expectedClass) {
      function validate(props, propName, componentName, location, propFullName) {
        if (!(props[propName] instanceof expectedClass)) {
          var expectedClassName = expectedClass.name || ANONYMOUS;
          var actualClassName = getClassName(props[propName]);
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }

    function createEnumTypeChecker(expectedValues) {
      if (!Array.isArray(expectedValues)) {
        warning_1$2(false, 'Invalid argument supplied to oneOf, expected an instance of array.');
        return emptyFunction_1$2.thatReturnsNull;
      }

      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        for (var i = 0; i < expectedValues.length; i++) {
          if (is(propValue, expectedValues[i])) {
            return null;
          }
        }

        var valuesString = JSON.stringify(expectedValues);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
      }
      return createChainableTypeChecker(validate);
    }

    function createObjectOfTypeChecker(typeChecker) {
      function validate(props, propName, componentName, location, propFullName) {
        if (typeof typeChecker !== 'function') {
          return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
        }
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== 'object') {
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
        }
        for (var key in propValue) {
          if (propValue.hasOwnProperty(key)) {
            var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1$2);
            if (error instanceof Error) {
              return error;
            }
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }

    function createUnionTypeChecker(arrayOfTypeCheckers) {
      if (!Array.isArray(arrayOfTypeCheckers)) {
        warning_1$2(false, 'Invalid argument supplied to oneOfType, expected an instance of array.');
        return emptyFunction_1$2.thatReturnsNull;
      }

      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        if (typeof checker !== 'function') {
          warning_1$2(
            false,
            'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
            'received %s at index %s.',
            getPostfixForTypeWarning(checker),
            i
          );
          return emptyFunction_1$2.thatReturnsNull;
        }
      }

      function validate(props, propName, componentName, location, propFullName) {
        for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
          var checker = arrayOfTypeCheckers[i];
          if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret_1$2) == null) {
            return null;
          }
        }

        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
      }
      return createChainableTypeChecker(validate);
    }

    function createNodeChecker() {
      function validate(props, propName, componentName, location, propFullName) {
        if (!isNode(props[propName])) {
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }

    function createShapeTypeChecker(shapeTypes) {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== 'object') {
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
        }
        for (var key in shapeTypes) {
          var checker = shapeTypes[key];
          if (!checker) {
            continue;
          }
          var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1$2);
          if (error) {
            return error;
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }

    function createStrictShapeTypeChecker(shapeTypes) {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== 'object') {
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
        }
        // We need to check all keys in case some are required but missing from
        // props.
        var allKeys = objectAssign$2({}, props[propName], shapeTypes);
        for (var key in allKeys) {
          var checker = shapeTypes[key];
          if (!checker) {
            return new PropTypeError(
              'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
              '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
              '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
            );
          }
          var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1$2);
          if (error) {
            return error;
          }
        }
        return null;
      }

      return createChainableTypeChecker(validate);
    }

    function isNode(propValue) {
      switch (typeof propValue) {
        case 'number':
        case 'string':
        case 'undefined':
          return true;
        case 'boolean':
          return !propValue;
        case 'object':
          if (Array.isArray(propValue)) {
            return propValue.every(isNode);
          }
          if (propValue === null || isValidElement(propValue)) {
            return true;
          }

          var iteratorFn = getIteratorFn(propValue);
          if (iteratorFn) {
            var iterator = iteratorFn.call(propValue);
            var step;
            if (iteratorFn !== propValue.entries) {
              while (!(step = iterator.next()).done) {
                if (!isNode(step.value)) {
                  return false;
                }
              }
            } else {
              // Iterator will provide entry [k,v] tuples rather than values.
              while (!(step = iterator.next()).done) {
                var entry = step.value;
                if (entry) {
                  if (!isNode(entry[1])) {
                    return false;
                  }
                }
              }
            }
          } else {
            return false;
          }

          return true;
        default:
          return false;
      }
    }

    function isSymbol(propType, propValue) {
      // Native Symbol.
      if (propType === 'symbol') {
        return true;
      }

      // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
      if (propValue['@@toStringTag'] === 'Symbol') {
        return true;
      }

      // Fallback for non-spec compliant Symbols which are polyfilled.
      if (typeof Symbol === 'function' && propValue instanceof Symbol) {
        return true;
      }

      return false;
    }

    // Equivalent of `typeof` but with special handling for array and regexp.
    function getPropType(propValue) {
      var propType = typeof propValue;
      if (Array.isArray(propValue)) {
        return 'array';
      }
      if (propValue instanceof RegExp) {
        // Old webkits (at least until Android 4.0) return 'function' rather than
        // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
        // passes PropTypes.object.
        return 'object';
      }
      if (isSymbol(propType, propValue)) {
        return 'symbol';
      }
      return propType;
    }

    // This handles more types than `getPropType`. Only used for error messages.
    // See `createPrimitiveTypeChecker`.
    function getPreciseType(propValue) {
      if (typeof propValue === 'undefined' || propValue === null) {
        return '' + propValue;
      }
      var propType = getPropType(propValue);
      if (propType === 'object') {
        if (propValue instanceof Date) {
          return 'date';
        } else if (propValue instanceof RegExp) {
          return 'regexp';
        }
      }
      return propType;
    }

    // Returns a string that is postfixed to a warning about an invalid type.
    // For example, "undefined" or "of type array"
    function getPostfixForTypeWarning(value) {
      var type = getPreciseType(value);
      switch (type) {
        case 'array':
        case 'object':
          return 'an ' + type;
        case 'boolean':
        case 'date':
        case 'regexp':
          return 'a ' + type;
        default:
          return type;
      }
    }

    // Returns class name of the object, if any.
    function getClassName(propValue) {
      if (!propValue.constructor || !propValue.constructor.name) {
        return ANONYMOUS;
      }
      return propValue.constructor.name;
    }

    ReactPropTypes.checkPropTypes = checkPropTypes_1$2;
    ReactPropTypes.PropTypes = ReactPropTypes;

    return ReactPropTypes;
  };

  var propTypes$2 = createCommonjsModule(function (module) {
  /**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */

  {
    var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
      Symbol.for &&
      Symbol.for('react.element')) ||
      0xeac7;

    var isValidElement = function(object) {
      return typeof object === 'object' &&
        object !== null &&
        object.$$typeof === REACT_ELEMENT_TYPE;
    };

    // By explicitly using `prop-types` you are opting into new development behavior.
    // http://fb.me/prop-types-in-prod
    var throwOnDirectAccess = true;
    module.exports = factoryWithTypeCheckers$2(isValidElement, throwOnDirectAccess);
  }
  });

  /**
   * 函数相关工具函数
   * @author surjinwu
   * @ignore created 2018-05-25
   */

  /**
   * noop -> Function
   */
  var noop = function noop() {};

  var Select =
  /*#__PURE__*/
  function (_React$Component) {
    _inherits(Select, _React$Component);

    function Select() {
      var _getPrototypeOf2;

      var _this;

      _classCallCheck(this, Select);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Select)).call.apply(_getPrototypeOf2, [this].concat(args)));

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "listNode", void 0);

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "scrollTo", function (element, to, duration) {
        if (duration <= 0) {
          element.scrollTop = to;
          return;
        }

        var difference = to - element.scrollTop;
        var perTick = difference / duration * 10;
        setTimeout(function () {
          element.scrollTop += perTick;

          if (element.scrollTop === to) {
            return;
          }

          _this.scrollTo(element, to, duration - 10);
        }, 10);
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "scrollToSelected", function (duration) {
        if (!_this.props.scrollToSelect) {
          return;
        }

        var select = ReactDOM.findDOMNode(_assertThisInitialized(_assertThisInitialized(_this)));
        var index = _this.props.value / _this.props.step;
        var topOption = _this.listNode.children[index];
        var to = topOption.offsetTop - select.offsetTop;

        _this.scrollTo(select, to, duration);
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "genRangeList", function (start, end, step) {
        return Array(Math.ceil((end - start + 1) / step)).fill(0).map(function (e, i) {
          var num = i * step + start;
          return num > 9 ? "".concat(num) : "0".concat(num);
        });
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleSelect", function (e, val) {
        e.stopPropagation();

        if (_this.props.onChange) {
          _this.props.onChange(val);
        }
      });

      return _this;
    }

    _createClass(Select, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        this.scrollToSelected(0);
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate() {
        this.scrollToSelected(150);
      }
      /**
       * 滚动到指定元素
       */

    }, {
      key: "render",
      value: function render() {
        var _this2 = this;

        var _this$props = this.props,
            from = _this$props.from,
            to = _this$props.to,
            value = _this$props.value,
            range = _this$props.range,
            step = _this$props.step;
        var list = this.genRangeList(from, to, step).map(function (item, i) {
          if (range.min != null && i < range.min) {
            return React.createElement("li", {
              key: i,
              className: "disabled"
            }, item);
          }

          if (range.max != null && i > range.max) {
            return React.createElement("li", {
              key: i,
              className: "disabled"
            }, item);
          }

          return React.createElement("li", {
            key: i,
            className: +item === value ? 'current' : '',
            onClick: function onClick(e) {
              return _this2.handleSelect(e, +item);
            }
          }, item);
        });
        return React.createElement("div", {
          className: "tc-time-picker-select"
        }, React.createElement("ul", {
          ref: function ref(node) {
            _this2.listNode = node;
          }
        }, list));
      }
    }]);

    return Select;
  }(React.Component);

  _defineProperty(Select, "defaultProps", {
    range: {},
    scrollToSelect: true,
    step: 1,
    onChange: noop
  });

  var keys = {
    38: 'up',
    40: 'down',
    13: 'enter'
    /**
     * 时间选择器
     */

  };

  var TimePicker =
  /*#__PURE__*/
  function (_React$Component) {
    _inherits(TimePicker, _React$Component);

    function TimePicker(_props) {
      var _this;

      _classCallCheck(this, TimePicker);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(TimePicker).call(this, _props));

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
        bubbleActive: false,
        active: false,
        currentValue: undefined
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "setupProps", function (props) {
        var isInit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

        var currentValue = _this.parseValue(props.value, props);

        var inputValue = _this.format(currentValue);

        if (isInit) {
          _this.state.currentValue = currentValue;
          _this.state.inputValue = inputValue;
        } else {
          _this.setState({
            currentValue: currentValue,
            inputValue: inputValue
          });
        }
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "inputNode", void 0);

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "format", function (value) {
        if (typeof value === 'string') {
          return value;
        }

        if (!value) {
          return '';
        }

        return moment(value).format(_this.getFormat());
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getFormat", function () {
        return _this.props.timeFormat != null ? _this.props.timeFormat : _this.props.format;
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "confirm", function (value) {
        var onChange = _this.props.onChange;

        _this.setState({
          currentValue: value,
          inputValue: _this.format(value)
        });

        onChange(_this.format(value), value);
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleInputChange", function (e) {
        var inputValue = e.target.value;

        var currentValue = _this.parseValue(inputValue);

        if (currentValue.isValid()) {
          _this.confirm(currentValue);

          _this.setState({
            bubbleActive: false
          });
        } else {
          _this.setState({
            bubbleActive: true
          });
        }

        _this.setState({
          inputValue: inputValue
        });
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "open", function () {
        if (!_this.state.active && !_this.props.disabled) {
          _this.setState({
            active: true
          });
        }
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "close", function () {
        _this.setState({
          active: false,
          bubbleActive: false
        });
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleClickOutside", function () {
        _this.close();
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "moment", function (value) {
        var mValue = moment(value);

        if (!mValue.isValid() && typeof value === 'string') {
          mValue = moment("".concat(moment().format('YYYY-MM-DD'), " ").concat(value));
        }

        return mValue;
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "parseValue", function (value, props) {
        props || (props = _this.props);
        var _props2 = props,
            range = _props2.range;

        if (value == null) {
          return value;
        }

        var mValue = _this.moment(value);

        if (range && _this.isOutOfRange(mValue)) {
          if (range.max) {
            return _this.moment(range.max);
          }

          if (range.min) {
            return _this.moment(range.min);
          }
        }

        return mValue;
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getNewValue", function (obj) {
        var year = obj.year,
            month = obj.month,
            day = obj.day,
            hour = obj.hour,
            minute = obj.minute,
            second = obj.second;
        var currentValue = _this.state.currentValue;
        var newValue = moment(currentValue);
        year != null && newValue.year(year);
        month != null && newValue.month(month);
        day != null && newValue.date(day);
        hour != null && newValue.hour(hour);
        minute != null && newValue.minute(minute);
        second != null && newValue.second(second);
        var times = 0;

        while (_this.isOutOfRange(newValue)) {
          obj.hour != null && newValue.minute((newValue.minute() + 1) % 60);
          obj.minute != null && newValue.second((newValue.second() + 1) % 60);

          if (++times > 60) {
            break;
          }
        }

        return _this.parseValue(newValue);
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleSelect", function (obj) {
        var newValue = _this.getNewValue(obj);

        _this.confirm(newValue);
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleKeyDown", function (e) {
        if (!keys[e.keyCode]) {
          return;
        }

        e.preventDefault();
        var input = e.currentTarget;
        var start = input.selectionStart;
        var end = input.selectionEnd;
        setImmediate(function () {
          return input.setSelectionRange(start, end);
        });
        var currentValue = _this.state.currentValue || {
          hour: 0,
          minute: 0,
          second: 0
        };
        var rst = {};

        switch (keys[e.keyCode]) {
          case 'up':
            if (start >= 0 && end <= 2) {
              rst.hour = (currentValue.hour() + 1) % 24;
            }

            if (start >= 3 && end <= 5) {
              rst.minute = (currentValue.minute() + 1) % 60;
            }

            if (start >= 6 && end <= 8) {
              rst.second = (currentValue.second() + 1) % 60;
            }

            break;

          case 'down':
            if (start >= 0 && end <= 2) {
              rst.hour = (currentValue.hour() - 1 + 24) % 24;
            }

            if (start >= 3 && end <= 5) {
              rst.minute = (currentValue.minute() - 1 + 60) % 60;
            }

            if (start >= 6 && end <= 8) {
              rst.second = (currentValue.second() - 1 + 60) % 60;
            }

            break;

          case 'enter':
            _this.close();

            _this.inputNode.blur();

            return;

          default:
            break;
        }

        var rstValue = _this.getNewValue(rst);

        _this.confirm(rstValue);
      });

      _this.setupProps(_props, true);

      return _this;
    }

    _createClass(TimePicker, [{
      key: "componentWillReceiveProps",
      value: function componentWillReceiveProps(nextProps) {
        this.setupProps(nextProps);
      }
    }, {
      key: "isOutOfRange",
      value: function isOutOfRange(mDate) {
        var range = this.props.range;

        if (!range.min && !range.max) {
          return false;
        }

        return range.max && mDate.isAfter(this.moment(range.max)) || range.min && mDate.isBefore(this.moment(range.min));
      }
    }, {
      key: "render",
      value: function render() {
        var _this2 = this;

        return React.createElement("div", {
          className: classnames(this.props.className, {
            active: this.state.active
          })
        }, React.createElement("div", {
          className: "tc-time-picker-input-wrap"
        }, React.createElement("input", {
          type: "text",
          ref: function ref(node) {
            _this2.inputNode = node;
          },
          className: "tc-15-input-text shortest",
          onClick: this.open,
          onFocus: this.open,
          placeholder: this.props.placeholder || '时间选择',
          value: this.state.inputValue,
          onChange: this.handleInputChange,
          disabled: this.props.disabled,
          onKeyDown: this.handleKeyDown,
          style: this.props.inputStyle,
          maxLength: 8
        }), React.createElement(Bubble, {
          position: "top",
          className: "error",
          style: {
            display: this.state.bubbleActive ? '' : 'none'
          }
        }, "\u683C\u5F0F\u9519\u8BEF\uFF0C\u5E94\u4E3A$", this.getFormat())), this.picker);
      }
    }, {
      key: "hasHour",
      get: function get() {
        return this.getFormat().toLowerCase().indexOf('h') > -1;
      }
    }, {
      key: "hasMinute",
      get: function get() {
        return this.getFormat().indexOf('m') > -1;
      }
    }, {
      key: "hasSecond",
      get: function get() {
        return this.getFormat().indexOf('s') > -1;
      }
    }, {
      key: "picker",
      get: function get() {
        var _this3 = this;

        var currentValue = this.state.currentValue;
        var hour = currentValue.hour();
        var minute = currentValue.minute();
        var second = currentValue.second();
        var range = this.props.range;
        var minRange = range.min ? this.moment(range.min) : null;
        var maxRange = range.max ? this.moment(range.max) : null;
        var hourRange = {
          min: minRange && minRange.hour(),
          max: maxRange && maxRange.hour()
        };
        var minuteRange = {};
        var secondRange = {};

        if (hour === hourRange.min) {
          minuteRange.min = minRange.minute();

          if ('min' in minuteRange && minute === minuteRange.min) {
            secondRange.min = minRange.second();
          }
        }

        if (hour === hourRange.max) {
          minuteRange.max = maxRange.minute();

          if ('max' in minuteRange && minute === minuteRange.max) {
            secondRange.max = maxRange.second();
          }
        }

        return this.state.active && React.createElement("div", {
          className: "tc-time-picker-combobox",
          style: {
            width: 55 * (+this.hasHour + +this.hasMinute + +this.hasSecond)
          }
        }, this.hasHour && React.createElement(Select, {
          from: 0,
          to: 23,
          value: hour,
          range: hourRange,
          scrollToSelect: this.props.scrollToSelect,
          step: this.props.hourStep,
          onChange: function onChange(value) {
            _this3.handleSelect({
              hour: value
            });
          }
        }), this.hasMinute && React.createElement(Select, {
          from: 0,
          to: 59,
          value: minute,
          range: minuteRange,
          scrollToSelect: this.props.scrollToSelect,
          step: this.props.minuteStep,
          onChange: function onChange(value) {
            _this3.handleSelect({
              minute: value
            });
          }
        }), this.hasSecond && React.createElement(Select, {
          from: 0,
          to: 59,
          value: second,
          range: secondRange,
          scrollToSelect: this.props.scrollToSelect,
          step: this.props.secondStep,
          onChange: function onChange(value) {
            _this3.handleSelect({
              second: value
            });
          }
        }));
      }
    }]);

    return TimePicker;
  }(React.Component);

  _defineProperty(TimePicker, "displayName", 'TimePicker');

  _defineProperty(TimePicker, "defaultProps", {
    value: new Date('1970-01-01 00:00:00'),
    range: {},
    onChange: function onChange() {},
    format: 'HH:mm:ss',
    timeFormat: null,
    hourStep: 1,
    minuteStep: 1,
    secondStep: 1,
    className: 'tc-time-picker',
    placeholder: undefined,
    inputStyle: {},
    scrollToSelect: true
  });

  var TimePicker$1 = enhanceWithClickOutside(TimePicker);

  function isOutOfRange(mDate, range, precision) {
    if (!range || range && !range.min && !range.max) {
      return false;
    }

    if (range.max && mDate.isAfter(moment(range.max), precision)) {
      return 1;
    }

    if (range.min && mDate.isBefore(moment(range.min), precision)) {
      return -1;
    }
  }
  function isInRange(date, range) {
    var unit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'd';

    if (!range || !range.min || !range.max) {
      return false;
    }

    if (date.isSame(range.min, unit)) {
      return 'min';
    }

    if (date.isSame(range.max, unit)) {
      return 'max';
    }

    if (date.isAfter(range.min, unit) && date.isBefore(range.max, unit)) {
      return true;
    }

    return false;
  }
  function getPrevMonth(_ref) {
    var year = _ref.year,
        month = _ref.month;
    return month > 0 ? {
      month: month - 1,
      year: year
    } : {
      month: 11,
      year: year - 1
    };
  }
  function getNextMonth(_ref2) {
    var year = _ref2.year,
        month = _ref2.month;
    return month < 11 ? {
      month: month + 1,
      year: year
    } : {
      month: 0,
      year: year + 1
    };
  }
  function getDefaultDateRangeList() {
    var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref3$hasWhole = _ref3.hasWhole,
        hasWhole = _ref3$hasWhole === void 0 ? false : _ref3$hasWhole,
        _ref3$excludeToday = _ref3.excludeToday,
        excludeToday = _ref3$excludeToday === void 0 ? false : _ref3$excludeToday;

    var now = moment();
    var ret = [];

    if (hasWhole) {
      ret.push({
        text: '全部',
        value: null
      });
    }

    if (!excludeToday) {
      ret.push({
        text: '今天',
        value: {
          from: moment(now).set({
            hour: 0,
            minute: 0,
            second: 0
          }),
          to: moment(now),
          index: 0
        }
      });
    }

    return ret.concat([{
      text: '昨天',
      value: {
        from: moment(now).subtract(1, 'd').set({
          hour: 0,
          minute: 0,
          second: 0
        }),
        to: moment(now).subtract(1, 'd').set({
          hour: 23,
          minute: 59,
          second: 59
        }),
        index: 1
      }
    }, {
      text: '近7天',
      value: {
        from: moment(now).subtract(7, 'd'),
        to: excludeToday ? moment(now).subtract(1, 'd').set({
          hour: 23,
          minute: 59,
          second: 59
        }) : moment(now),
        index: 2
      }
    }, {
      text: '近30天',
      value: {
        from: moment(now).subtract(30, 'd'),
        to: excludeToday ? moment(now).subtract(1, 'd').set({
          hour: 23,
          minute: 59,
          second: 59
        }) : moment(now),
        index: 3
      }
    }]);
  }

  var MonthCalendar =
  /*#__PURE__*/
  function (_React$Component) {
    _inherits(MonthCalendar, _React$Component);

    function MonthCalendar() {
      var _getPrototypeOf2;

      var _this;

      _classCallCheck(this, MonthCalendar);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(MonthCalendar)).call.apply(_getPrototypeOf2, [this].concat(args)));

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleBtnClick", function (_ref) {
        var month = _ref.month,
            year = _ref.year;

        _this.props.onMonthChange({
          month: month,
          year: year
        });
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleSelect", function (date) {
        _this.props.onDayChange(date);
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleCellHover", function (e, date) {
        _this.props.onDayHover(e, date);
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "calendarRender", function () {
        var _this$props = _this.props,
            range = _this$props.range,
            year = _this$props.year,
            month = _this$props.month,
            value = _this$props.value,
            selectionRange = _this$props.selectionRange,
            valueIsRange = _this$props.valueIsRange;

        if (selectionRange == null && valueIsRange && value != null) {
          selectionRange = {
            min: value.from,
            max: value.to
          };
        } // 本月第一天


        var firstDate = new Date(year, month, 1);
        var day = firstDate.getDay(); // 获取本月有多少天

        var lastDate = new Date(year, month + 1, 0);
        var count = lastDate.getDate();
        var weeks = [];

        var _loop = function _loop(_i) {
          var week = []; // 第一周补全

          for (var j = 0; j < day % 7; ++j) {
            week.push(React.createElement("td", {
              key: "dis-".concat(j),
              className: "tc-15-calendar-dis"
            }));
          } // 填充一周


          do {
            (function (day) {
              var cur = moment({
                year: year,
                month: month,
                day: day // ...time

              });
              var inRange = null;
              var isSame;
              var isFirst;
              var isLast;
              var outOfRange = isOutOfRange(cur, range, 'd');

              if (valueIsRange) {
                inRange = isInRange(cur, selectionRange);
                isFirst = value && value.from && cur.isSame(value.from, 'd');
                isLast = value && value.to && cur.isSame(value.to, 'd');
              } else {
                isSame = cur.isSame(value, 'd');
              }

              week.push(React.createElement("td", {
                key: day,
                className: classnames({
                  'tc-15-calendar-first': isFirst,
                  'tc-15-calendar-last': isLast,
                  'tc-15-calendar-current': inRange && !isFirst && !isLast,
                  'tc-15-calendar-today': isSame === true,
                  'tc-15-calendar-dis': outOfRange
                }),
                onClick: function onClick() {
                  if (outOfRange) {
                    i = _i;
                    // 现在 isSame 状态下仍可点击
                    return;
                  }

                  _this.handleSelect({
                    year: year,
                    month: month,
                    day: day
                  }, cur);
                },
                onMouseOver: function onMouseOver(e) {
                  if (isSame || outOfRange) {
                    i = _i;
                    return;
                  }

                  _this.handleCellHover(e, cur);
                }
              }, day));
            })(_i++);

            if (_i > count) {
              break;
            }
          } while (++day % 7 !== 0);

          weeks.push(React.createElement("tr", {
            key: "week-".concat(_i / 7)
          }, week));
          i = _i;
        };

        for (var i = 1; i <= count;) {
          _loop(i);
        }

        return weeks;
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "prevBtnRender", function () {
        var _this$props2 = _this.props,
            range = _this$props2.range,
            year = _this$props2.year,
            month = _this$props2.month;

        if (range.min) {
          var min = moment(range.min);

          if (min.year() >= year && min.month() >= month) {
            return React.createElement("i", {
              tabIndex: 0,
              className: "tc-15-calendar-i-pre-m disabled"
            }, React.createElement("b", null, React.createElement("span", null, "\u8FC7\u53BB\u65F6\u95F4\u4E0D\u53EF\u9009")));
          }
        }

        return React.createElement("i", {
          tabIndex: 0,
          className: "tc-15-calendar-i-pre-m",
          onClick: function onClick() {
            _this.handleBtnClick(getPrevMonth({
              year: year,
              month: month
            }));
          }
        }, React.createElement("b", null, React.createElement("span", null, "\u8F6C\u5230\u4E0A\u4E2A\u6708")));
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "nextBtnRender", function () {
        var _this$props3 = _this.props,
            range = _this$props3.range,
            year = _this$props3.year,
            month = _this$props3.month;

        if (range.max) {
          var maxRange = moment(range.max);

          if (maxRange.year() <= year && maxRange.month() <= month) {
            return React.createElement("i", {
              tabIndex: 0,
              className: "tc-15-calendar-i-next-m disabled"
            }, React.createElement("b", null, React.createElement("span", null, "\u672A\u6765\u65F6\u95F4\u4E0D\u53EF\u9009")));
          }
        }

        return React.createElement("i", {
          tabIndex: 0,
          className: "tc-15-calendar-i-next-m",
          onClick: function onClick() {
            _this.handleBtnClick(getNextMonth({
              year: year,
              month: month
            }));
          }
        }, React.createElement("b", null, React.createElement("span", null, "\u8F6C\u5230\u4E0B\u4E2A\u6708")));
      });

      return _this;
    }

    _createClass(MonthCalendar, [{
      key: "render",
      value: function render() {
        return React.createElement("table", {
          cellSpacing: 0,
          className: "tc-15-calendar-left"
        }, React.createElement("caption", null, this.caption), React.createElement("thead", null, React.createElement("tr", null, moment.weekdaysMin().map(function (val, key) {
          return React.createElement("th", {
            key: key
          }, val);
        }))), React.createElement("tbody", null, React.createElement("tr", null, React.createElement("td", {
          colSpan: 3
        }, this.prevBtnRender()), React.createElement("td", {
          colSpan: 4
        }, this.nextBtnRender())), this.calendarRender()));
      }
    }, {
      key: "caption",
      get: function get() {
        var _this$props4 = this.props,
            year = _this$props4.year,
            month = _this$props4.month;
        var monthStr = moment.monthsShort()[month];
        var locale = moment.locale();

        if (locale === 'en') {
          return "".concat(monthStr, " ").concat(year);
        }

        return "".concat(year, "\u5E74").concat(monthStr);
      }
    }]);

    return MonthCalendar;
  }(React.Component);

  _defineProperty(MonthCalendar, "displayName", 'MonthCalendar');

  _defineProperty(MonthCalendar, "defaultProps", {
    value: undefined,
    year: undefined,
    month: undefined,
    range: {},
    selectionRange: undefined,
    valueIsRange: false,
    onMonthChange: function onMonthChange() {},
    onDayChange: function onDayChange() {},
    onDayHover: function onDayHover() {}
  });

  var keys$1 = {
    13: 'enter'
    /**
     * 日期（时间）选择器，主要用于单个日期（时间）输入
     */

  };

  var DatePicker =
  /*#__PURE__*/
  function (_React$Component) {
    _inherits(DatePicker, _React$Component);

    function DatePicker(props) {
      var _this;

      _classCallCheck(this, DatePicker);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(DatePicker).call(this, props));

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
        active: false,
        bubbleActive: false
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "inputNode", void 0);

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "format", function (value) {
        if (typeof value === 'string') {
          return value;
        }

        if (!value) {
          return '';
        }

        return moment(value).format(_this.getFormat());
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getCaption", function () {
        var _this$state = _this.state,
            year = _this$state.currentYear,
            currentMonth = _this$state.currentMonth;
        var month = currentMonth + 1;
        var version = _this.props.version || window.VERSION;

        if (version === 'en') {
          return "".concat(moment.monthsShort()[month + 1], " ").concat(year);
        }

        var monthStr = month > 9 ? "".concat(month) : "0".concat(month);
        return "".concat(year, "\u5E74").concat(monthStr, "\u6708");
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "confirm", function (value) {
        var inputValue = _this.format(value);

        _this.setState({
          currentValue: value,
          inputValue: inputValue
        });

        if (_this.props.onChange) {
          _this.props.onChange(inputValue, value);
        }
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleInputChange", function (e) {
        var inputValue = e.target.value;
        var isValid = moment(inputValue).isValid();

        if (isValid) {
          _this.confirm(inputValue);
        }

        _this.setState({
          bubbleActive: !isValid
        });

        _this.setState({
          inputValue: inputValue
        });
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getNewValue", function (_ref) {
        var year = _ref.year,
            month = _ref.month,
            day = _ref.day,
            hour = _ref.hour,
            minute = _ref.minute,
            second = _ref.second;
        var currentValue = _this.state.currentValue;
        var newValue = moment(currentValue);
        year != null && newValue.year(year);
        month != null && newValue.month(month);
        day != null && newValue.date(day);
        hour != null && newValue.hour(hour);
        minute != null && newValue.minute(minute);
        second != null && newValue.second(second);
        return _this.parseValue(newValue);
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "parseValue", function (value) {
        var range = _this.props.range;

        if (value == null) {
          return value;
        }

        var mValue = moment(value);

        if (range && _this.isOutOfRange(mValue)) {
          if (range.max) {
            return moment(range.max);
          }

          if (range.min) {
            return moment(range.min);
          }
        }

        return mValue;
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "open", function () {
        if (!_this.state.active && !_this.props.disabled) {
          var currentValue = _this.state.currentValue;

          _this.setState({
            currentYear: currentValue.year(),
            currentMonth: currentValue.month(),
            active: true
          });
        }
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleClickOutside", function () {
        _this.close();
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "close", function () {
        _this.setState({
          active: false,
          bubbleActive: false
        });
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleKeyDown", function (e) {
        if (!keys$1[e.keyCode]) {
          return;
        }

        e.preventDefault();

        switch (keys$1[e.keyCode]) {
          case 'enter':
            _this.handleConfirm();

            _this.inputNode.blur();

            break;
        }
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleSelect", function (_ref2) {
        var year = _ref2.year,
            month = _ref2.month,
            day = _ref2.day;

        var value = _this.getNewValue({
          year: year,
          month: month,
          day: day
        });

        if (_this.hasConfirm) {
          _this.setState({
            currentValue: value
          });
        } else {
          _this.confirm(value);

          setTimeout(function () {
            return _this.close();
          }, 100);
        }
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleConfirm", function () {
        var value = _this.state.currentValue;

        _this.confirm(value);

        setTimeout(function () {
          return _this.close();
        }, 100);
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleMonthChange", function (_ref3) {
        var month = _ref3.month,
            year = _ref3.year;

        _this.setState({
          currentMonth: month,
          currentYear: year
        });
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleCancel", function () {
        _this.close();
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleTimeChange", function (str, value) {
        var currentValue = _this.getNewValue({
          hour: value.hour(),
          minute: value.minute(),
          second: value.second()
        });

        _this.setState({
          currentValue: currentValue
        });
      });

      _this.setupValue(props, true);

      return _this;
    }

    _createClass(DatePicker, [{
      key: "setupValue",
      value: function setupValue(props) {
        var isInit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var hasInit=false;
        var currentValue = this.parseValue(new Date().getTime());
        if(props.value) {
           currentValue = this.parseValue(props.value)
           hasInit=true;
        }
        var inputValue = hasInit ? this.format(currentValue):'';
        var currentYear = currentValue.year();
        var currentMonth = currentValue.month();

        if (isInit) {
          this.state.currentValue = currentValue;
          this.state.inputValue = inputValue;
          this.state.currentYear = currentYear;
          this.state.currentMonth = currentMonth;
        } else {
          this.setState({
            currentValue: currentValue,
            inputValue: inputValue,
            currentYear: currentYear,
            currentMonth: currentMonth
          });
        }
      }
    }, {
      key: "componentWillReceiveProps",
      value: function componentWillReceiveProps(nextProps) {
        this.setupValue(nextProps);
      }
    }, {
      key: "getFormat",
      value: function getFormat() {
        if (this.props.format) {
          return this.props.format;
        }

        if (this.props.type === 'date') {
          return 'YYYY-MM-DD';
        }

        return 'YYYY-MM-DD HH:mm:ss';
      }
    }, {
      key: "isOutOfRange",
      value: function isOutOfRange(mDate) {
        var range = this.props.range;

        if (!range.min && !range.max) {
          return false;
        }

        if (range.max) {
          return mDate.isAfter(moment(range.max), 'day');
        }

        if (range.min) {
          return mDate.isBefore(moment(range.min), 'day');
        }
      }
    }, {
      key: "render",
      value: function render() {
        var _this2 = this;

        var _this$state2 = this.state,
            currentYear = _this$state2.currentYear,
            currentMonth = _this$state2.currentMonth,
            currentValue = _this$state2.currentValue;
        var range = {};

        if (this.props.range) {
          range.min = this.props.range.min;
          range.max = this.props.range.max;
        }

        return React.createElement("div", {
          className: "tc-15-calendar-select-wrap tc-15-calendar2-hook"
        }, React.createElement("div", {
          className: classnames('tc-15-calendar-select', 'tc-15-calendar-single', {
            show: this.state.active
          })
        }, React.createElement("button", {
          ref: function ref(node) {
            _this2.inputNode = node;
          },
          className: classnames('tc-15-simulate-select tc-15-btn m show', {
            disabled: this.props.disabled
          }),
          disabled: this.props.disabled,
          onClick: this.open
        },   React.createElement("span", {
          style: {
            color:!this.state.inputValue ? '#bbb':''
          }
        },this.state.inputValue ? this.state.inputValue: this.props.placeholder || '请选择'
        )),React.createElement(Bubble, {
          position: "top",
          className: "error",
          style: {
            display: this.state.bubbleActive ? '' : 'none'
          }
        }, "\u9519\u8BEF\u7684\u65E5\u671F\u683C\u5F0F"), React.createElement("div", {
          className: "tc-15-calendar-triangle-wrap"
        }), React.createElement("div", {
          className: "tc-15-calendar-triangle"
        }), React.createElement("div", {
          className: "tc-15-calendar tc-15-calendar2"
        }, React.createElement("div", {
          className: "tc-15-calendar-cont"
        }, React.createElement(MonthCalendar, {
          className: "tc-15-calendar-left",
          value: currentValue,
          year: currentYear,
          month: currentMonth,
          range: range,
          onMonthChange: this.handleMonthChange,
          onDayChange: this.handleSelect,
          isStart: this.props.isStart
        })), this.isDateTime && React.createElement(TimePicker$1, {
          range: this.timeRange,
          value: this.state.currentValue,
          onChange: this.handleTimeChange
        }), this.props.text && React.createElement("div", {
          className: "tc-15-calendar-cont",
          style: {
            paddingTop: 12
          }
        }, this.props.text), this.hasConfirm && React.createElement("div", {
          className: "tc-15-calendar-footer"
        }, React.createElement("div", {
          className: "tc-15-calendar-btns"
        }, React.createElement("button", {
          className: "tc-15-btn m",
          onClick: this.handleConfirm
        }, "\u786E\u5B9A"), React.createElement("button", {
          className: "tc-15-btn m weak",
          onClick: this.handleCancel
        }, "\u53D6\u6D88"))), React.createElement("div", {
          className: "tc-15-calendar-for-style"
        }))));
      }
    }, {
      key: "isDateTime",
      get: function get() {
        return this.props.type === 'datetime';
      }
    }, {
      key: "hasConfirm",
      get: function get() {
        return this.props.type === 'datetime' || this.props.hasConfirm;
      }
    }, {
      key: "timeRange",
      get: function get() {
        var currentValue = this.state.currentValue;
        var range = this.props.range;
        var rst = {};

        if (range.min && currentValue.isSame(range.min, 'day')) {
          rst.min = range.min;
        }

        if (range.max && currentValue.isSame(range.max, 'day')) {
          rst.max = range.max;
        }

        return rst;
      }
    }]);

    return DatePicker;
  }(React.Component);

  _defineProperty(DatePicker, "displayName", 'DatePicker');

  _defineProperty(DatePicker, "defaultProps", {
    type: 'date',
    // datetime & date
    range: {},
    // { min, max }
    value: new Date(),
    format: undefined,
    disabled: false,
    hasConfirm: false,
    text: undefined,
    onChange: function onChange() {},
    isStart: true,
    placeholder: null,
  });

  var DatePicker$1 = enhanceWithClickOutside(DatePicker);

//wolf

function getPrevMonthMMDD(_ref) {
  var year = _ref.year,
      month = _ref.month;
  return month > 0 ? {
    month: month - 1,
    year: year
  } : {
    month: 11,
    year: year - 1
  };
}
function getNextMonthMMDD(_ref2) {
  var year = _ref2.year,
      month = _ref2.month;
  return month < 11 ? {
    month: month + 1,
    year: year
  } : {
    month: 0,
    year: year + 1
  };
}
var MonthCalendarMMDD =
/*#__PURE__*/
function (_React$Component) {
  _inherits(MonthCalendarMMDD, _React$Component);

  function MonthCalendarMMDD() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, MonthCalendarMMDD);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(MonthCalendarMMDD)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleBtnClick", function (_ref) {
      var month = _ref.month,
          year = _ref.year;

      _this.props.onMonthChange({
        month: month,
        year: year
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleSelect", function (date) {
      _this.props.onDayChange(date);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleCellHover", function (e, date) {
      _this.props.onDayHover(e, date);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "calendarRender", function () {
      var _this$props = _this.props,
          range = _this$props.range,
          year = _this$props.year,
          month = _this$props.month,
          value = _this$props.value,
          selectionRange = _this$props.selectionRange,
          valueIsRange = _this$props.valueIsRange;

      if (selectionRange == null && valueIsRange && value != null) {
        selectionRange = {
          min: value.from,
          max: value.to
        };
      } // 本月第一天


      var firstDate = new Date(year, month, 1);
      var day = 0 // 获取本月有多少天

      var lastDate = new Date(year, month + 1, 0);
      var count = lastDate.getDate()==29?28:lastDate.getDate();
      var weeks = [];

      var _loop = function _loop(_i) {
        var week = []; // 第一周补全

        for (var j = 0; j < day % 7; ++j) {
          week.push(React.createElement("td", {
            key: "dis-".concat(j),
            className: "tc-15-calendar-dis"
          }));
        } // 填充一周


        do {
          (function (day) {
            var cur = moment({
              year: year,
              month: month,
              day: day // ...time

            });
            var inRange = null;
            var isSame;
            var isFirst;
            var isLast;
            var outOfRange = isOutOfRange(cur, range, 'd');

            if (valueIsRange) {
              inRange = isInRange(cur, selectionRange);
              isFirst = value && value.from && cur.isSame(value.from, 'd');
              isLast = value && value.to && cur.isSame(value.to, 'd');
            } else {
              isSame = cur.isSame(value, 'd');
            }

            week.push(React.createElement("td", {
              key: day,
              className: classnames({
                'tc-15-calendar-first': isFirst,
                'tc-15-calendar-last': isLast,
                'tc-15-calendar-current': inRange && !isFirst && !isLast,
                'tc-15-calendar-today': isSame === true,
                'tc-15-calendar-dis': outOfRange
              }),
              onClick: function onClick() {
                if (outOfRange) {
                  i = _i;
                  // 现在 isSame 状态下仍可点击
                  return;
                }

                _this.handleSelect({
                  year: year,
                  month: month,
                  day: day
                }, cur);
              },
              onMouseOver: function onMouseOver(e) {
                if (isSame || outOfRange) {
                  i = _i;
                  return;
                }

                _this.handleCellHover(e, cur);
              }
            }, day));
          })(_i++);

          if (_i > count) {
            break;
          }
        } while (++day % 7 !== 0);

        weeks.push(React.createElement("tr", {
          key: "week-".concat(_i / 7)
        }, week));
        i = _i;
      };

      for (var i = 1; i <= count;) {
        _loop(i);
      }

      return weeks;
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "prevBtnRender", function () {
      var _this$props2 = _this.props,
          range = _this$props2.range,
          year = _this$props2.year,
          month = _this$props2.month;

      if (true) {
        var min = moment(range.min);

        if (0 >= month) {
          return React.createElement("i", {
            tabIndex: 0,
            className: "tc-15-calendar-i-pre-m disabled"
          }, React.createElement("b", null, React.createElement("span", null, "\u8FC7\u53BB\u65F6\u95F4\u4E0D\u53EF\u9009")));
        }
      }

      return React.createElement("i", {
        tabIndex: 0,
        className: "tc-15-calendar-i-pre-m",
        onClick: function onClick() {
          _this.handleBtnClick(getPrevMonthMMDD({
            year: year,
            month: month
          }));
        }
      }, React.createElement("b", null, React.createElement("span", null, "\u8F6C\u5230\u4E0A\u4E2A\u6708")));
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "nextBtnRender", function () {
      var _this$props3 = _this.props,
          range = _this$props3.range,
          year = _this$props3.year,
          month = _this$props3.month;

          if (true) {
        var maxRange = moment(range.max);

        if (11 <= month) {
          return React.createElement("i", {
            tabIndex: 0,
            className: "tc-15-calendar-i-next-m disabled"
          }, React.createElement("b", null, React.createElement("span", null, "\u672A\u6765\u65F6\u95F4\u4E0D\u53EF\u9009")));
        }
      }

      return React.createElement("i", {
        tabIndex: 0,
        className: "tc-15-calendar-i-next-m",
        onClick: function onClick() {
          _this.handleBtnClick(getNextMonthMMDD({
            year: year,
            month: month
          }));
        }
      }, React.createElement("b", null, React.createElement("span", null, "\u8F6C\u5230\u4E0B\u4E2A\u6708")));
    });

    return _this;
  }

  
  _createClass(MonthCalendarMMDD, [{
    key: "render",
    value: function render() {
      return React.createElement("table", {
        cellSpacing: 0,
        className: "tc-15-calendar-left"
      }, React.createElement("caption", null, this.caption)
      // , React.createElement("thead", null, React.createElement("tr", null, moment.weekdaysMin().map(function (val, key) {
        // return React.createElement("th", {
          // key: key
        // }, val);
      // })))
      , React.createElement("tbody", null, React.createElement("tr", null, React.createElement("td", {
        colSpan: 3
      }, this.prevBtnRender()), React.createElement("td", {
        colSpan: 4
      }, this.nextBtnRender())), this.calendarRender()));
    }
  }, {
    key: "caption",
    get: function get() {
      var _this$props4 = this.props,
          year = _this$props4.year,
          month = _this$props4.month;
      var monthStr = moment.monthsShort()[month];
      var locale = moment.locale();

      if (locale === 'en') {
        return "".concat(monthStr, " ")
        // .concat(year);
      }

      return "".concat(monthStr);
      // .concat(year, "\u5E74")
    }
  }]);

  return MonthCalendarMMDD;
}(React.Component);

_defineProperty(MonthCalendarMMDD, "displayName", 'MonthCalendarMMDD');

_defineProperty(MonthCalendarMMDD, "defaultProps", {
  value: undefined,
  year: undefined,
  month: undefined,
  range: {},
  selectionRange: undefined,
  valueIsRange: false,
  onMonthChange: function onMonthChange() {},
  onDayChange: function onDayChange() {},
  onDayHover: function onDayHover() {}
});



var DatePickerMMDD =
/*#__PURE__*/
function (_React$Component) {
  _inherits(DatePicker, _React$Component);

  function DatePicker(props) {
    var _this;

    _classCallCheck(this, DatePicker);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DatePicker).call(this, props));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
      active: false,
      bubbleActive: false
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "inputNode", void 0);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "format", function (value) {
      if (typeof value === 'string') {
        return value;
      }

      if (!value) {
        return '';
      }

      return moment(value).format(_this.getFormat());
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getCaption", function () {
      var _this$state = _this.state,
          year = _this$state.currentYear,
          currentMonth = _this$state.currentMonth;
      var month = currentMonth + 1;
      var version = _this.props.version || window.VERSION;

      if (version === 'en') {
        return "".concat(moment.monthsShort()[month + 1], " ").concat(year);
      }

      var monthStr = month > 9 ? "".concat(month) : "0".concat(month);
      return "".concat(year, "\u5E74").concat(monthStr, "\u6708");
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "confirm", function (value) {
      var inputValue = _this.format(value);
      console.log(inputValue)
      _this.setState({
        currentValue: value,
        inputValue: inputValue
      });

      if (_this.props.onChange) {
        _this.props.onChange(inputValue, value);
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleInputChange", function (e) {
      var inputValue = e.target.value;
      var isValid = moment(inputValue).isValid();

      if (isValid) {
        _this.confirm(inputValue);
      }

      _this.setState({
        bubbleActive: !isValid
      });

      _this.setState({
        inputValue: inputValue
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getNewValue", function (_ref) {
      var year = _ref.year,
          month = _ref.month,
          day = _ref.day,
          hour = _ref.hour,
          minute = _ref.minute,
          second = _ref.second;
      var currentValue = _this.state.currentValue;
      var newValue = moment(currentValue);
      year != null && newValue.year(year);
      month != null && newValue.month(month);
      day != null && newValue.date(day);
      hour != null && newValue.hour(hour);
      minute != null && newValue.minute(minute);
      second != null && newValue.second(second);
      return _this.parseValue(newValue);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "parseValue", function (value) {
      var range = _this.props.range;

      if (value == null) {
        return value;
      }

      var mValue = moment(value);

      if (range && _this.isOutOfRange(mValue)) {
        if (range.max) {
          return moment(range.max);
        }

        if (range.min) {
          return moment(range.min);
        }
      }

      return mValue;
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "open", function () {
      if (!_this.state.active && !_this.props.disabled) {
        var currentValue = _this.state.currentValue;

        _this.setState({
          currentYear: currentValue.year(),
          currentMonth: currentValue.month(),
          active: true
        });
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleClickOutside", function () {
      _this.close();
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "close", function () {
      _this.setState({
        active: false,
        bubbleActive: false
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleKeyDown", function (e) {
      if (!keys$1[e.keyCode]) {
        return;
      }

      e.preventDefault();

      switch (keys$1[e.keyCode]) {
        case 'enter':
          _this.handleConfirm();

          _this.inputNode.blur();

          break;
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleSelect", function (_ref2) {
      var year = _ref2.year,
          month = _ref2.month,
          day = _ref2.day;

      var value = _this.getNewValue({
        year: year,
        month: month,
        day: day
      });

      if (_this.hasConfirm) {
        _this.setState({
          currentValue: value
        });
      } else {
        _this.confirm(value);

        setTimeout(function () {
          return _this.close();
        }, 100);
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleConfirm", function () {
      var value = _this.state.currentValue;
      console.log(value)
      _this.confirm(value);

      setTimeout(function () {
        return _this.close();
      }, 100);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleMonthChange", function (_ref3) {
      var month = _ref3.month,
          year = _ref3.year;

      _this.setState({
        currentMonth: month,
        currentYear: year
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleCancel", function () {
      _this.close();
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleTimeChange", function (str, value) {
      var currentValue = _this.getNewValue({
        hour: value.hour(),
        minute: value.minute(),
        second: value.second()
      });

      _this.setState({
        currentValue: currentValue
      });
    });

    _this.setupValue(props, true);

    return _this;
  }

  _createClass(DatePicker, [{
    key: "setupValue",
    value: function setupValue(props) {
      var isInit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var hasInit=false;
      var currentValue = this.parseValue(new Date().getTime());
      if(props.value) {
         currentValue = this.parseValue(props.value)
         hasInit=true;
      }
      var inputValue = hasInit ? this.format(currentValue):'';
      var currentYear = currentValue.year();
      var currentMonth = currentValue.month();

      if (isInit) {
        this.state.currentValue = currentValue;
        this.state.inputValue = inputValue;
        this.state.currentYear = currentYear;
        this.state.currentMonth = currentMonth;
      } else {
        this.setState({
          currentValue: currentValue,
          inputValue: inputValue,
          currentYear: currentYear,
          currentMonth: currentMonth
        });
      }
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      this.setupValue(nextProps);
    }
  }, {
    key: "getFormat",
    value: function getFormat() {
      if (this.props.format) {
        return this.props.format;
      }

      if (this.props.type === 'date') {
        return 'MM-DD';
      }

      return 'MM-DD HH:mm:ss';
    }
  }, {
    key: "isOutOfRange",
    value: function isOutOfRange(mDate) {
      var range = this.props.range;

      if (!range.min && !range.max) {
        return false;
      }

      if (range.max) {
        return mDate.isAfter(moment(range.max), 'day');
      }

      if (range.min) {
        return mDate.isBefore(moment(range.min), 'day');
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$state2 = this.state,
          currentYear = _this$state2.currentYear,
          currentMonth = _this$state2.currentMonth,
          currentValue = _this$state2.currentValue;
      var range = {};

      if (this.props.range) {
        range.min = this.props.range.min;
        range.max = this.props.range.max;
      }

      return React.createElement("div", {
        className: "tc-15-calendar-select-wrap tc-15-calendar2-hook"
      }, React.createElement("div", {
        className: classnames('tc-15-calendar-select', 'tc-15-calendar-single', {
          show: this.state.active
        })
      }, React.createElement("button", {
        ref: function ref(node) {
          _this2.inputNode = node;
        },
        className: classnames('tc-15-simulate-select tc-15-btn m show', {
          disabled: this.props.disabled
        }),
        disabled: this.props.disabled,
        onClick: this.open
      },   React.createElement("span", {
        style: {
          color:!this.state.inputValue ? '#bbb':''
        }
      },this.state.inputValue ? this.state.inputValue: this.props.placeholder || '请选择'
      )),React.createElement(Bubble, {
        position: "top",
        className: "error",
        style: {
          display: this.state.bubbleActive ? '' : 'none'
        }
      }, "\u9519\u8BEF\u7684\u65E5\u671F\u683C\u5F0F"), React.createElement("div", {
        className: "tc-15-calendar-triangle-wrap"
      }), React.createElement("div", {
        className: "tc-15-calendar-triangle"
      }), React.createElement("div", {
        className: "tc-15-calendar tc-15-calendar2"
      }, React.createElement("div", {
        className: "tc-15-calendar-cont"
      }, React.createElement(MonthCalendarMMDD, {
        className: "tc-15-calendar-left",
        value: currentValue,
        year: currentYear,
        month: currentMonth,
        range: range,
        onMonthChange: this.handleMonthChange,
        onDayChange: this.handleSelect,
        isStart: this.props.isStart
      })), this.isDateTime && React.createElement(TimePicker$1, {
        range: this.timeRange,
        value: this.state.currentValue,
        onChange: this.handleTimeChange
      }), this.props.text && React.createElement("div", {
        className: "tc-15-calendar-cont",
        style: {
          paddingTop: 12
        }
      }, this.props.text), this.hasConfirm && React.createElement("div", {
        className: "tc-15-calendar-footer"
      }, React.createElement("div", {
        className: "tc-15-calendar-btns"
      }, React.createElement("button", {
        className: "tc-15-btn m",
        onClick: this.handleConfirm
      }, "\u786E\u5B9A"), React.createElement("button", {
        className: "tc-15-btn m weak",
        onClick: this.handleCancel
      }, "\u53D6\u6D88"))), React.createElement("div", {
        className: "tc-15-calendar-for-style"
      }))));
    }
  }, {
    key: "isDateTime",
    get: function get() {
      return this.props.type === 'datetime';
    }
  }, {
    key: "hasConfirm",
    get: function get() {
      return this.props.type === 'datetime' || this.props.hasConfirm;
    }
  }, {
    key: "timeRange",
    get: function get() {
      var currentValue = this.state.currentValue;
      var range = this.props.range;
      var rst = {};

      if (range.min && currentValue.isSame(range.min, 'day')) {
        rst.min = range.min;
      }

      if (range.max && currentValue.isSame(range.max, 'day')) {
        rst.max = range.max;
      }

      return rst;
    }
  }]);

  return DatePicker;
}(React.Component);

_defineProperty(DatePickerMMDD, "displayName", 'DatePicker');

_defineProperty(DatePickerMMDD, "defaultProps", {
  type: 'date',
  // datetime & date
  range: {},
  // { min, max }
  value: new Date(),
  format: undefined,
  disabled: false,
  hasConfirm: false,
  text: undefined,
  onChange: function onChange() {},
  isStart: true,
  placeholder: null,
});

var DatePickerMMDD$1 = enhanceWithClickOutside(DatePickerMMDD);


//wolf



  var DateTimePicker =
  /*#__PURE__*/
  function (_React$Component) {
    _inherits(DateTimePicker, _React$Component);

    function DateTimePicker() {
      _classCallCheck(this, DateTimePicker);

      return _possibleConstructorReturn(this, _getPrototypeOf(DateTimePicker).apply(this, arguments));
    }

    _createClass(DateTimePicker, [{
      key: "render",
      value: function render() {
        return React.createElement(DatePicker$1, _extends({
          type: "datetime"
        }, this.props));
      }
    }]);

    return DateTimePicker;
  }(React.Component);

  /**
   * 日期范围选择器，主要用于含有开始和结束的日期选择
   */

  var DateRangePicker =
  /*#__PURE__*/
  function (_React$Component) {
    _inherits(DateRangePicker, _React$Component);

    function DateRangePicker(props) {
      var _this;

      _classCallCheck(this, DateRangePicker);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(DateRangePicker).call(this, props));

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
        active: false,
        currentYear: null,
        currentMonth: null,
        currentValue: null,
        selectionRange: null,
        fromInputValue: '',
        toInputValue: ''
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleMonthChange", function (_ref) {
        var month = _ref.month,
            year = _ref.year;

        _this.setState({
          currentMonth: month,
          currentYear: year
        });
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleDayChange", function (value, status) {
        value = moment(value);
        status || (status = _this.rangeStatus);
        var currentValue;

        if (status === 'done' || status === 'none') {
          currentValue = {
            from: value
          };
        } else {
          var existValue = status === 'from' ? _this.state.currentValue.from : _this.state.currentValue.to;

          if (existValue.isAfter(value)) {
            currentValue = {
              from: value,
              to: existValue
            };
          } else {
            currentValue = {
              from: existValue,
              to: value
            };
          }
        }

        _this.setState({
          currentValue: currentValue,
          selectionRange: null,
          fromInputValue: _this.format(currentValue.from),
          toInputValue: _this.format(currentValue.to)
        });

        _this.props.onDayChange && _this.props.onDayChange(currentValue);
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleDayHover", function (e, date) {
        var status = _this.rangeStatus;

        if (status === 'from') {
          var min = _this.state.currentValue.from;

          if (date.isBefore(min)) {
            _this.setState({
              selectionRange: {
                min: date,
                max: min
              },
              currentValue: {
                to: min
              },
              toInputValue: _this.format(min),
              fromInputValue: ''
            });
          } else {
            _this.setState({
              selectionRange: {
                min: min,
                max: date
              }
            });
          }
        }

        if (status === 'to') {
          var max = _this.state.currentValue.to;

          if (date.isAfter(max)) {
            _this.setState({
              selectionRange: {
                min: max,
                max: date
              },
              currentValue: {
                from: max
              },
              toInputValue: '',
              fromInputValue: _this.format(max)
            });
          } else {
            _this.setState({
              selectionRange: {
                min: date,
                max: max
              }
            });
          }
        }
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleCancelClick", function () {
        _this.setupValue(_this.props, false, true);

        _this.close();
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleConfirmClick", function () {
        if (_this.rangeStatus === 'done') {
          _this.props.onChange(_this.state.currentValue);

          _this.close();
        }
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleClickOutside", function () {
        _this.handleCancelClick();
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleTriggerClick", function () {
        _this.setState({
          active: true
        });
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "close", function () {
        _this.setState({
          active: false
        });
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "format", function (value) {
        return value ? value.format(_this.props.format) : '';
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "isValid", function (str) {
        return moment(str, _this.props.format).isValid();
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleFromValueBlur", function (e) {
        var val = _this.state.fromInputValue;

        if (_this.isValid(val)) {
          _this.handleDayChange(moment("".concat(val, " 00:00:00")), 'to');
        } else {
          _this.setState({
            fromInputValue: _this.format(_this.state.currentValue.from)
          });
        }
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleToValueBlur", function (e) {
        var val = _this.state.toInputValue;

        if (_this.isValid(val)) {
          _this.handleDayChange(moment("".concat(val, " 23:59:59")), 'from');
        } else {
          _this.setState({
            toInputValue: _this.format(_this.state.currentValue.to)
          });
        }
      });

      _this.setupValue(props, true);

      return _this;
    }

    _createClass(DateRangePicker, [{
      key: "setupValue",
      value: function setupValue(props) {
        var isInit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var isForce = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

        if (isForce || isInit || props.value !== this.props.value) {
          var currentValue = props.value == null ? {} : {
            from: moment(props.value.from),
            to: moment(props.value.to)
          };
          var now = moment();
          var currentYear = currentValue.from ? currentValue.from.year() : now.year();
          var currentMonth = currentValue.from ? currentValue.from.month() : now.month();
          var fromInputValue = currentValue.from ? this.format(currentValue.from) : '';
          var toInputValue = currentValue.to ? this.format(currentValue.to) : '';

          if (isInit) {
            this.state.currentValue = currentValue;
            this.state.currentYear = currentYear;
            this.state.currentMonth = currentMonth;
            this.state.fromInputValue = fromInputValue;
            this.state.toInputValue = toInputValue;
            this.state.selectionRange = null;
          } else {
            this.setState({
              currentValue: currentValue,
              currentYear: currentYear,
              currentMonth: currentMonth,
              fromInputValue: fromInputValue,
              toInputValue: toInputValue,
              selectionRange: null
            });
          }
        }

        if (props.isUntilNow && !props.range.max) {
          props.range.max = moment();
        }
      }
    }, {
      key: "componentWillReceiveProps",
      value: function componentWillReceiveProps(nextProps) {
        this.setupValue(nextProps);
      }
    }, {
      key: "render",
      value: function render() {
        var _this2 = this;

        var _this$state = this.state,
            currentYear = _this$state.currentYear,
            currentMonth = _this$state.currentMonth,
            currentValue = _this$state.currentValue,
            selectionRange = _this$state.selectionRange,
            active = _this$state.active;

        var _getNextMonth = getNextMonth({
          year: currentYear,
          month: currentMonth
        }),
            nextYear = _getNextMonth.year,
            nextMonth = _getNextMonth.month;

        var _this$props = this.props,
            range = _this$props.range,
            className = _this$props.className;
        return React.createElement("div", {
          className: classnames('tc-15-calendar-select tc-15-calendar-select-wrap tc-15-calendar2-hook', {
            show: active
          }, className)
        }, React.createElement("button", {
          className: "tc-15-simulate-select m show",
          onClick: this.handleTriggerClick
        }, this.displayValue), React.createElement("div", {
          className: "tc-15-calendar-triangle-wrap"
        }), React.createElement("div", {
          className: "tc-15-calendar-triangle"
        }), React.createElement("div", {
          className: "tc-15-calendar tc-15-calendar2"
        }, React.createElement("div", {
          className: "tc-15-calendar-cont"
        }, React.createElement(MonthCalendar, {
          className: "tc-15-calendar-left",
          range: range,
          year: currentYear,
          month: currentMonth,
          value: currentValue,
          valueIsRange: true,
          selectionRange: selectionRange,
          onMonthChange: this.handleMonthChange,
          onDayChange: this.handleDayChange,
          onDayHover: this.handleDayHover
        }), React.createElement(MonthCalendar, {
          range: range,
          year: nextYear,
          month: nextMonth,
          value: currentValue,
          valueIsRange: true,
          selectionRange: selectionRange,
          onMonthChange: function onMonthChange(_ref2) {
            var month = _ref2.month,
                year = _ref2.year;

            var _getPrevMonth = getPrevMonth({
              year: year,
              month: month
            });

            month = _getPrevMonth.month;
            year = _getPrevMonth.year;

            _this2.handleMonthChange({
              year: year,
              month: month
            });
          },
          onDayChange: this.handleDayChange,
          onDayHover: this.handleDayHover
        })), React.createElement("div", {
          className: "tc-15-calendar-footer"
        }, this.props.hasInput && React.createElement("div", {
          className: "tc-15-calendar-input"
        }, React.createElement("div", {
          className: "tc-15-input-text-wrap m"
        }, React.createElement("input", {
          type: "text",
          className: "tc-15-input-text",
          value: this.state.fromInputValue,
          onChange: function onChange(e) {
            var val = e.target.value;

            _this2.setState({
              fromInputValue: val
            });
          },
          onBlur: this.handleFromValueBlur
        })), React.createElement("span", {
          role: "separator"
        }, "\u81F3"), React.createElement("div", {
          className: "tc-15-input-text-wrap m"
        }, React.createElement("input", {
          type: "text",
          className: "tc-15-input-text",
          value: this.state.toInputValue,
          onChange: function onChange(e) {
            var val = e.target.value;

            _this2.setState({
              toInputValue: val
            });
          },
          onBlur: this.handleToValueBlur
        }))), React.createElement("div", {
          className: "tc-15-calendar-btns"
        }, React.createElement("button", {
          className: "tc-15-btn m",
          onClick: this.handleConfirmClick
        }, "\u786E\u5B9A"), React.createElement("button", {
          className: "tc-15-btn m weak",
          onClick: this.handleCancelClick
        }, "\u53D6\u6D88"))), React.createElement("div", {
          className: "tc-15-calendar-for-style"
        })));
      }
    }, {
      key: "displayValue",
      get: function get() {
        var _this$props2 = this.props,
            value = _this$props2.value,
            format = _this$props2.format;

        if (value == null) {
          return '';
        }

        var from = value.from,
            to = value.to;

        if (from) {
          return "".concat(moment(from).format(format), " \u81F3 ").concat(moment(to).format(format));
        }
      }
    }, {
      key: "rangeStatus",
      get: function get() {
        var currentValue = this.state.currentValue;

        if (currentValue.from && currentValue.to) {
          return 'done';
        }

        if (currentValue.from) {
          return 'from';
        }

        if (currentValue.to) {
          return 'to';
        }

        return 'none';
      }
    }]);

    return DateRangePicker;
  }(React.Component);

  _defineProperty(DateRangePicker, "displayName", 'DateRangePicker');

  _defineProperty(DateRangePicker, "defaultProps", {
    format: 'YYYY-MM-DD',
    isUntilNow: true,
    range: {},
    value: {},
    hasInput: true,
    onChange: function onChange() {},
    onDayChange: function onDayChange() {},
  });

  var DateRangePicker$1 = enhanceWithClickOutside(DateRangePicker);

  /**
   * 日期时间范围选择器
   *
   * props中时间单位为s，乘unit转化为ms
   */

  var DateTimeRangePicker =
  /*#__PURE__*/
  function (_React$Component) {
    _inherits(DateTimeRangePicker, _React$Component);

      function DateTimeRangePicker(_props) {
        var _this;

        _classCallCheck(this, DateTimeRangePicker);

        _this = _possibleConstructorReturn(this, _getPrototypeOf(DateTimeRangePicker).call(this, _props));

        _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {});

        _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getInitState", function (props) {
          var value = props.value,
            range = props.range;
          var date = new Date()

          var valueFrom = value.from ? moment(value.from) : moment(new Date(date.getFullYear() +'-'+ (date.getMonth() + 1)  +'-'+ date.getDate() ));
          var valueTo = value.to ? moment(value.to) : moment(new Date(date.getFullYear()  +'-'+  (date.getMonth() + 1)  +'-'+  date.getDate() ));
          var rangeFrom = {};
          var rangeTo = {};

          if (range.min) {
            rangeFrom.min = moment(range.min);
            rangeTo.min = moment(range.min);
          }

          if (range.max) {
            rangeFrom.max = moment(range.max);
          rangeTo.max = moment(range.max);
        }

        return {
          first:value.from&& value.to ?true:false,
          valueFrom: valueFrom,
          valueTo: valueTo,
          rangeFrom: rangeFrom,
          rangeTo: rangeTo
        };
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getNormalizeState", function (_ref, props) {
        var first= _ref.first,
        rangeFrom = _ref.rangeFrom,
            rangeTo = _ref.rangeTo,
            valueFrom = _ref.valueFrom,
            valueTo = _ref.valueTo;
        props || (props = _this.props);
        var _props2 = props,
            range = _props2.range,
            duration = _props2.duration;

        if (valueFrom) {
          rangeTo.min = valueFrom;

          if (range.maxLength) {
            var max = _this.getDurationValue(valueFrom, range.maxLength);

            rangeTo.max = range.max && max.isAfter(range.max) ? range.max : max;
          }
        }

        if (valueTo) {
          if (!range.maxLength && !duration) {
            rangeFrom.max = valueTo;
          } // if (range.maxLength) {
          //   const min = this.getDurationValue(valueTo, range.maxLength, '-')
          //   rangeFrom.min = rangeFrom.min && min.isBefore(rangeFrom.min)
          //     ? rangeFrom.min
          //     : min
          // }

        }

        if (valueFrom && duration) {
          valueTo = _this.getDurationValue(valueFrom, duration); // valueTo = rangeTo.max && to.isAfter(rangeTo.max)
          //   ? moment(rangeTo.max)
          //   : to
        }

        var rst = {};

        if (_this.props.isUntilNow) {
          var now = moment();

          if (rangeTo) {
            if (rangeTo.max) {
              rangeTo.max = rangeTo.max.isAfter(now) ? now : rangeTo.max;
            } else {
              rangeTo.max = now;
            }
          }

          if (rangeFrom) {
            if (rangeFrom.max) {
              rangeFrom.max = rangeFrom.max.isAfter(now) ? now : rangeFrom.max;
            } else {
              rangeFrom.max = now;
            }
          }
        }

        if (valueFrom) {
          rst.valueFrom = valueFrom;
        }

        if (valueTo) {
          rst.valueTo = valueTo;
        }

        if (rangeTo) {
          rst.rangeTo = _objectSpread({}, rangeTo);
        }

        if (rangeFrom) {
          rst.rangeFrom = _objectSpread({}, rangeFrom);
        }

        if (first) {
          rst.first = first;
        }

        return _this.checkValue(rst);
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "format", function (date) {
        return moment(date).format(_this.props.format);
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "open", function () {
        if (_this.props.disabled) {
          return;
        }

        _this.setState({
          active: true,
        });
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleSubmit", function () {
        var _this$state = _this.state,
            valueFrom = _this$state.valueFrom,
            valueTo = _this$state.valueTo; // const previousInputValue = this.state.inputValue

        var currentInputValue = _this.getInputValue({
          from: valueFrom,
          to: valueTo
        }); // if (previousInputValue === currentInputValue) {
        //   return
        // }


        if (_this.props.onChange) {
          _this.props.onChange({
            from: valueFrom,
            fromFormat: valueFrom && valueFrom.format && valueFrom.format(_this.props.format),
            to: valueTo,
            toFormat: valueTo && valueTo.format && valueTo.format(_this.props.format)
          });
        }

        _this.setState({
          active: false,
          first:true,
          inputValue: currentInputValue,

        });
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleClickOutside", function () {
        _this.handleCancel();
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleCancel", function () {
        _this.setState({
          active: false
        });
      });

      var state = _this.getNormalizeState(_this.getInitState(_props));

      var inputValue = _this.getInputValue({
        from: state.valueFrom,
        to: state.valueTo
      });

      _this.state = _objectSpread({
        active: false,
        tabIndex: null,
        inputValue: inputValue,
        
      }, state);
      return _this;
    }

    _createClass(DateTimeRangePicker, [{
      key: "componentWillReceiveProps",
      value: function componentWillReceiveProps(nextProps) {
        // duration可变
        var state = this.getNormalizeState(this.getInitState(nextProps), nextProps);
        var inputValue = this.getInputValue({
          from: state.valueFrom,
          to: state.valueTo
        });
        this.setState(_objectSpread({
          inputValue: inputValue,
          first:state.first
        }, state));
      }
    }, {
      key: "getTimeRange",
      value: function getTimeRange(value, range) {
        var rst = {};

        if (range.min && value.isSame(range.min, 'day')) {
          rst.min = range.min;
        }

        if (range.max && value.isSame(range.max, 'day')) {
          rst.max = range.max;
        }

        return rst;
      }
    }, {
      key: "getDurationValue",
      value: function getDurationValue(value, duration) {
        var symbol = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '+';
        var num;
        var unit;

        if (typeof duration === 'string') {
          var sp = duration.split(/(\d+)/).filter(function (d) {
            return d;
          });
          num = +sp[0];
          unit = sp[1] || 's';
        } else {
          num = duration;
          unit = 'ms';
        }

        if (symbol === '-') {
          return moment(value).subtract(num, unit);
        }

        return moment(value).add(num, unit);
      }
    }, {
      key: "setValueState",
      value: function setValueState(_ref2) {
        var valueFrom = _ref2.valueFrom,
            valueTo = _ref2.valueTo;
        var _this$state2 = this.state,
            rangeFrom = _this$state2.rangeFrom,
            rangeTo = _this$state2.rangeTo;
        var newState = this.getNormalizeState({
          valueFrom: valueFrom,
          valueTo: valueTo,
          rangeFrom: rangeFrom,
          rangeTo: rangeTo
        });
        this.setState(_objectSpread({}, newState));
      }
    }, {
      key: "adjuctValue",
      value: function adjuctValue(value, range) {
        if (range && isOutOfRange(value, range)) {
          if (range.max) {
            return moment(range.max);
          }

          if (range.min) {
            return moment(range.min);
          }
        }

        return value;
      }
    }, {
      key: "checkValue",
      value: function checkValue(newState) {
        var rangeFrom = newState.rangeFrom || this.state.rangeFrom;
        var rangeTo = newState.rangeTo || this.state.rangeTo;
        var valueFrom = newState.valueFrom;
        var valueTo = newState.valueTo; // const valueFrom = newState.valueFrom || this.state.valueFrom
        // const valueTo = newState.valueTo || this.state.valueTo

        var rst = _objectSpread({}, newState);

        if (newState.valueFrom) {
          valueFrom = this.adjuctValue(newState.valueFrom, rangeFrom); // if (!newState.valueTo) {
          //   valueTo = this.adjuctValue(this.state.valueTo, rangeTo)
          // }

          rst.valueFrom = valueFrom;
        }

        if (newState.valueTo) {
          valueTo = this.adjuctValue(newState.valueTo, rangeTo); // if (!newState.valueFrom) {
          //   valueFrom = this.adjuctValue(this.state.valueFrom, rangeFrom)
          // }

          rst.valueTo = valueTo;
        }

        return rst;
      }
    }, {
      key: "getInputValue",
      value: function getInputValue(_ref3) {
        var from = _ref3.from,
            to = _ref3.to;
        var format = this.props.format;

        if (!from) {
          return;
        }

        return "".concat(from ? from.format(format) : '', " \u81F3 ").concat(to ? to.format(format) : '');
      }
    }, {
      key: "render",
      value: function render() {
        var _this2 = this;

        var _this$state3 = this.state,
            valueFrom = _this$state3.valueFrom,
            valueTo = _this$state3.valueTo,
            rangeFrom = _this$state3.rangeFrom,
            rangeTo = _this$state3.rangeTo,
            
            inputValue = _this$state3.inputValue,// 时间起止范围
            first=_this$state3.first;

        var timeRangeFrom = valueFrom ? this.getTimeRange(valueFrom, rangeFrom) : {};
        var timeRangeTo = valueTo ? this.getTimeRange(valueTo, rangeTo) : {};
        return React.createElement("div", {
          className: classnames('tc-15-dropdown tc-15-dropdown-btn-style date-dropdown', {
            'tc-15-menu-active': this.state.active,
            disabled: this.props.disabled
          })
        }, React.createElement("a", {
          className: "tc-15-dropdown-link",
          onClick: this.open,
          onFocus: this.open
        }, React.createElement("i", {
          className: "caret"
        }), (first&&inputValue) || this.props.placeholder), React.createElement("div", {
          className: "tc-15-dropdown-menu",
          role: "menu"
        }, React.createElement("div", {
          className: "tc-custom-date"
        }, React.createElement("div", {
          className: "custom-date-wrap"
        }, React.createElement("em", null, "\u4ECE"), React.createElement("div", {
          className: "calendar-box"
        }, React.createElement(DatePicker$1, {
          value: valueFrom,
          range: rangeFrom,
          onChange: function onChange(str, value) {
            _this2.setValueState({
              valueFrom: value
            });
          },
          version: this.props.version
        }), React.createElement(TimePicker$1, {
          value: valueFrom,
          range: timeRangeFrom,
          onChange: function onChange(str, value) {
            _this2.setValueState({
              valueFrom: value
            });
          }
        }))), React.createElement("div", {
          className: "custom-date-wrap"
        }, React.createElement("em", null, "\u81F3"), React.createElement("div", {
          className: "calendar-box"
        }, React.createElement(DatePicker$1, {
          value: valueTo,
          disabled: this.props.duration,
          range: rangeTo,
          isStart: false,
          onChange: function onChange(dateTo, value) {
            _this2.setValueState({
              valueTo: value
            });
          },
          version: this.props.version
        }), React.createElement(TimePicker$1, {
          value: this.state.valueTo,
          range: timeRangeTo,
          disabled: this.props.duration,
          onChange: function onChange(timeTo, value) {
            _this2.setValueState({
              valueTo: value
            });
          }
        })))), React.createElement("div", {
          className: "custom-date-ft"
        }, React.createElement("button", {
          type: "button",
          className: "tc-15-btn m",
          onClick: this.handleSubmit
        }, "\u786E\u5B9A"), "\xA0", React.createElement("button", {
          type: "button",
          className: "tc-15-btn m weak",
          onClick: this.handleCancel
        }, "\u53D6\u6D88"))));
      }
    }]);

    return DateTimeRangePicker;
  }(React.Component);

  _defineProperty(DateTimeRangePicker, "displayName", 'DateTimeRangePicker');

  _defineProperty(DateTimeRangePicker, "defaultProps", {
    placeholder: '选择日期',
    disabled: false,
    value: {},
    onChange: function onChange() {},
    duration: undefined,
    range: {},
    isUntilNow: true,
    format: 'YYYY-MM-DD HH:mm:ss'
  });

  var DateTimeRangePicker$1 = enhanceWithClickOutside(DateTimeRangePicker);

  var DateRangePickerEx =
  /*#__PURE__*/
  function (_React$Component) {
    _inherits(DateRangePickerEx, _React$Component);

    function DateRangePickerEx(props) {
      var _this;

      _classCallCheck(this, DateRangePickerEx);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(DateRangePickerEx).call(this, props));

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
        active: false,
        currentYear: null,
        currentMonth: null,
        currentValue: null,
        selectionRange: null,
        fromInputValue: '',
        toInputValue: ''
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleMonthChange", function (_ref) {
        var month = _ref.month,
            year = _ref.year;

        _this.setState({
          currentMonth: month,
          currentYear: year
        });
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleDayChange", function (value, status) {
        value = moment(value);
        status || (status = _this.rangeStatus);
        var currentValue;

        if (status === 'done' || status === 'none') {
          currentValue = {
            from: value
          };
        } else {
          var existValue = status === 'from' ? _this.state.currentValue.from : _this.state.currentValue.to;

          if (existValue.isAfter(value)) {
            currentValue = {
              from: value,
              to: existValue
            };
          } else {
            currentValue = {
              from: existValue,
              to: value
            };
          }
        }

        _this.setState({
          currentValue: currentValue,
          selectionRange: null,
          fromInputValue: _this.format(currentValue.from),
          toInputValue: _this.format(currentValue.to)
        });

        _this.props.onDayChange && _this.props.onDayChange(currentValue);
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleDayHover", function (e, date) {
        var status = _this.rangeStatus;

        if (status === 'from') {
          var min = _this.state.currentValue.from;

          if (date.isBefore(min)) {
            _this.setState({
              selectionRange: {
                min: date,
                max: min
              },
              currentValue: {
                to: min
              },
              toInputValue: _this.format(min)
            });
          } else {
            _this.setState({
              selectionRange: {
                min: min,
                max: date
              }
            });
          }
        }

        if (status === 'to') {
          var max = _this.state.currentValue.to;

          if (date.isAfter(max)) {
            _this.setState({
              selectionRange: {
                min: max,
                max: date
              },
              currentValue: {
                from: max
              },
              fromInputValue: _this.format(max)
            });
          } else {
            _this.setState({
              selectionRange: {
                min: date,
                max: max
              }
            });
          }
        }
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleCancelClick", function () {
        _this.setupValue(_this.props, false, true);

        _this.close();
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleConfirmClick", function () {
        if (_this.rangeStatus === 'done') {
          _this.props.onChange(_this.state.currentValue);

          _this.close();
        }
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleClickOutside", function () {
        _this.handleCancelClick();
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleTriggerClick", function () {
        _this.setState({
          active: true
        });
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "close", function () {
        _this.setState({
          active: false
        });
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "format", function (value) {
        return value ? value.format(_this.props.format) : '';
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "isValid", function (str) {
        return moment(str, _this.props.format).isValid();
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleFromValueBlur", function (e) {
        var val = _this.state.fromInputValue;

        if (_this.isValid(val)) {
          _this.handleDayChange(moment("".concat(val, " 00:00:00")), 'to');
        } else {
          _this.setState({
            fromInputValue: _this.format(_this.state.currentValue.from)
          });
        }
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleToValueBlur", function (e) {
        var val = _this.state.toInputValue;

        if (_this.isValid(val)) {
          _this.handleDayChange(moment("".concat(val, " 23:59:59")), 'from');
        } else {
          _this.setState({
            toInputValue: _this.format(_this.state.currentValue.to)
          });
        }
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleTabClick", function (tabValue) {
        var currentValue = {
          from: moment(tabValue.from),
          to: moment(tabValue.to)
        };

        _this.setState({
          currentValue: currentValue,
          selectionRange: null,
          fromInputValue: _this.format(tabValue.from),
          toInputValue: _this.format(tabValue.to)
        });

        _this.props.onChange(currentValue);
      });

      _this.setupValue(props, true);

      return _this;
    }

    _createClass(DateRangePickerEx, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        var _this$props = this.props,
            value = _this$props.value,
            defaultTab = _this$props.defaultTab;

        if (value.from == null && value.to == null) {
          if (defaultTab != null) {
            this.props.onChange(this.tabs[defaultTab].value);
          }
        }
      }
    }, {
      key: "setupValue",
      value: function setupValue(props) {
        var isInit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var isForce = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

        if (isForce || isInit || props.value !== this.props.value) {
          var currentValue = props.value == null ? {} : {
            from: moment(props.value.from),
            to: moment(props.value.to)
          };
          var now = moment();
          var currentYear = currentValue.from ? currentValue.from.year() : now.year();
          var currentMonth = currentValue.from ? currentValue.from.month() : now.month();
          var fromInputValue = currentValue.from ? this.format(currentValue.from) : '';
          var toInputValue = currentValue.to ? this.format(currentValue.to) : '';

          if (isInit) {
            this.state.currentValue = currentValue;
            this.state.currentYear = currentYear;
            this.state.currentMonth = currentMonth;
            this.state.fromInputValue = fromInputValue;
            this.state.toInputValue = toInputValue;
            this.state.selectionRange = null;
          } else {
            this.setState({
              currentValue: currentValue,
              currentYear: currentYear,
              currentMonth: currentMonth,
              fromInputValue: fromInputValue,
              toInputValue: toInputValue,
              selectionRange: null
            });
          }
        }

        if (props.isUntilNow && !props.range.max) {
          props.range.max = moment();
        }
      }
    }, {
      key: "componentWillReceiveProps",
      value: function componentWillReceiveProps(nextProps) {
        this.setupValue(nextProps);
      }
    }, {
      key: "render",
      value: function render() {
        var _this2 = this;

        var _this$state = this.state,
            currentYear = _this$state.currentYear,
            currentMonth = _this$state.currentMonth,
            currentValue = _this$state.currentValue,
            selectionRange = _this$state.selectionRange,
            active = _this$state.active;

        var _getNextMonth = getNextMonth({
          year: currentYear,
          month: currentMonth
        });

        var _this$props2 = this.props,
            range = _this$props2.range,
            className = _this$props2.className;

        var _this$props3 = this.props,
            tabs = _this$props3.tabs,
            defaultTab = _this$props3.defaultTab,
            rest = _objectWithoutProperties(_this$props3, ["tabs", "defaultTab"]);

        return React.createElement("div", {
          className: classnames('tc-15-calendar-select tc-15-calendar-select-wrap tc-15-calendar2-hook', {
            show: active
          }, className)
        }, React.createElement("div", {
          role: "tablist"
        }, this.tabs.map(function (tab, idx) {
          // 当分钟数相等，则认为是同样的时间
          var val = _this2.props.value;
          var isCurrent = moment(tab.value.from).isSame(val.from, 'm') && moment(tab.value.to).isSame(val.to, 'm');
          return React.createElement("span", {
            key: idx,
            role: "tab",
            tabIndex: "0",
            className: classnames({
              current: isCurrent
            }),
            onClick: function onClick() {
              _this2.handleTabClick(tab.value);
            }
          }, tab.render ? tab.render(tab) : tab.text);
        })), React.createElement(DateRangePicker$1, rest));
      }
    }, {
      key: "tabs",
      get: function get() {
        return this.props.tabs || getDefaultDateRangeList();
      }
    }, {
      key: "displayValue",
      get: function get() {
        var _this$props4 = this.props,
            value = _this$props4.value,
            format = _this$props4.format;

        if (value == null) {
          return '';
        }

        var from = value.from,
            to = value.to;

        if (from) {
          return "".concat(moment(from).format(format), " \u81F3 ").concat(moment(to).format(format));
        }
      }
    }, {
      key: "rangeStatus",
      get: function get() {
        var currentValue = this.state.currentValue;

        if (currentValue.from && currentValue.to) {
          return 'done';
        }

        if (currentValue.from) {
          return 'from';
        }

        if (currentValue.to) {
          return 'to';
        }

        return 'none';
      }
    }]);

    return DateRangePickerEx;
  }(React.Component);

  _defineProperty(DateRangePickerEx, "displayName", 'DateRangePickerEx');

  _defineProperty(DateRangePickerEx, "defaultProps", {
    format: 'YYYY-MM-DD',
    isUntilNow: true,
    hasInput: true,
    range: {},
    value: {},
    onChange: function onChange() {},
    onDayChange: function onDayChange() {},
    tabs: undefined,
    defaultTab: undefined
  });

  var DateRangePickerEx$1 = enhanceWithClickOutside(DateRangePickerEx);
  /* eslint-disable */

  /**
   * 带 “今天”、“昨天”、“近7天”、“近30天”的范围时间选择器，不是很通用，文档略
   */

  var DateTimeRangePickerEx =
  /*#__PURE__*/
  function (_React$Component) {
    _inherits(DateTimeRangePickerEx, _React$Component);

    function DateTimeRangePickerEx() {
      var _getPrototypeOf2;

      var _this;

      _classCallCheck(this, DateTimeRangePickerEx);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(DateTimeRangePickerEx)).call.apply(_getPrototypeOf2, [this].concat(args)));

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleChange", function (value) {
        var duration = _this.getDuration(value);

        if (Array.isArray(value) && value.length === 1) {
          _this.props.onChange(value[0], duration);
        } else {
          _this.props.onChange(value, duration);
        }
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleTabClick", function (tabValue) {
        var value = _this.getValueArray();

        value[0] = tabValue;

        _this.handleChange(value);
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleItemChange", function (idx, value) {
        var ret = _this.getValueArray();

        ret[idx] = value;

        _this.handleChange(ret);
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleRemoveClick", function (idx, value) {
        var ret = _this.getValueArray();

        ret.splice(idx, 1);

        _this.handleChange(ret);
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleAddClick", function () {
        var value = _this.getValueArray();

        var firstItem = value[0];
        value.push({
          from: moment(firstItem.from),
          to: moment(firstItem.to)
        });

        _this.handleChange(value);
      });

      return _this;
    }

    _createClass(DateTimeRangePickerEx, [{
      key: "getValueArray",
      value: function getValueArray(val) {
        var value = val == null ? this.props.value : val;

        if (!Array.isArray(value)) {
          value = [value];
        }

        return _toConsumableArray(value);
      }
    }, {
      key: "getDuration",
      value: function getDuration(value) {
        var firstItem = this.getValueArray(value)[0];
        var duration = moment(firstItem.to).diff(moment(firstItem.from), 'ms');
        return duration;
      }
    }, {
      key: "componentDidMount",
      value: function componentDidMount() {
        var _this$props = this.props,
            value = _this$props.value,
            defaultTab = _this$props.defaultTab;

        if (value.from == null && value.to == null) {
          if (defaultTab != null) {
            this.handleChange(this.tabs[defaultTab].value);
          }
        }
      }
    }, {
      key: "render",
      value: function render() {
        var _this2 = this;

        var _this$props2 = this.props,
            value = _this$props2.value,
            enableCompare = _this$props2.enableCompare,
            range = _this$props2.range,
            className = _this$props2.className,
            compareMaxCount = _this$props2.compareMaxCount;
        var valueArray = this.getValueArray();
        return React.createElement("div", {
          className: classnames('tc-15-calendar-select-wrap tc-15-calendar2-hook', className)
        }, valueArray.length === 1 && React.createElement("div", {
          role: "tablist"
        }, this.tabs.map(function (tab, idx) {
          var val = Array.isArray(value) ? value[0] : value; // 当分钟数相等，则认为是同样的时间

          var isCurrent = moment(tab.value.from).isSame(val.from, 'm') && moment(tab.value.to).isSame(val.to, 'm');
          return React.createElement("span", {
            key: idx,
            role: "tab",
            tabIndex: "0",
            className: classnames({
              current: isCurrent
            }),
            onClick: function onClick() {
              _this2.handleTabClick(tab.value);
            }
          }, tab.text);
        })), valueArray.map(function (item, idx) {
          var duration;

          if (idx !== 0) {
            duration = _this2.getDuration();
          }

          return React.createElement("span", {
            key: idx
          }, idx !== 0 && React.createElement("span", {
            className: "canlder-txt"
          }, "\u5BF9\u6BD4"), React.createElement(DateTimeRangePicker$1, {
            key: idx,
            value: item,
            range: range,
            duration: duration,
            onChange: function onChange(v) {
              _this2.handleItemChange(idx, v);
            }
          }), idx !== 0 && React.createElement("a", {
            href: "javascript:",
            onClick: function onClick() {
              _this2.handleRemoveClick(idx);
            }
          }, React.createElement("i", {
            className: "remove-icon"
          })));
        }), enableCompare && valueArray.length < compareMaxCount ? React.createElement("span", {
          className: "canlder-txt addtime"
        }, "\xA0", React.createElement("a", {
          href: "javascript:",
          onClick: this.handleAddClick
        }, "\u6DFB\u52A0\u65F6\u95F4\u5BF9\u6BD4")) : null);
      }
    }, {
      key: "tabs",
      get: function get() {
        return this.props.tabs || getDefaultDateRangeList();
      }
    }]);

    return DateTimeRangePickerEx;
  }(React.Component);
  /* eslint-disable */


  _defineProperty(DateTimeRangePickerEx, "displayName", 'DateTimeRangePickerEx');

  _defineProperty(DateTimeRangePickerEx, "defaultProps", {
    tabs: undefined,
    defaultTab: undefined,
    value: {},
    onChange: function onChange() {},
    enableCompare: false,
    compareMaxCount: 3,
    range: undefined
  });

  var months = [[0, 1, 2, 3], [4, 5, 6, 7], [8, 9, 10, 11]];
  /**
   * 月份选择器
   */

  var MonthPicker =
  /*#__PURE__*/
  function (_React$Component) {
    _inherits(MonthPicker, _React$Component);

    function MonthPicker(_props) {
      var _this;

      _classCallCheck(this, MonthPicker);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(MonthPicker).call(this, _props));

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "setupValue", function (props) {
        var isInit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var date = moment(props.value);
        var year = date.year();
        var min = props.range.min ? moment(props.range.min) : null;
        var max = props.range.max ? moment(props.range.max) : null;
        var state = {
          value: date,
          min: min,
          max: max,
          year: year
        };

        if (isInit) {
          _this.state = _objectSpread({}, _this.state, state);
        } else {
          _this.setState(state);
        }
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleYearChange", function (incr) {
        _this.setState({
          year: _this.state.year + incr
        });
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleMonthChange", function (date) {
        _this.setState({
          value: date
        }, function () {
          _this.props.onChange(date.format(_this.props.format));

          _this.close();
        });
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleShowClick", function () {
        if (!_this.props.disabled) {
          _this.setState({
            active: !_this.state.active
          });
        }
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleClickOutside", function () {
        _this.close();
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "close", function () {
        _this.setState({
          active: false
        });
      });

      _this.state = {
        active: false
      };

      _this.setupValue(_props, true);

      return _this;
    }

    _createClass(MonthPicker, [{
      key: "componentWillReceiveProps",
      value: function componentWillReceiveProps(nextProps) {
        this.setupValue(nextProps);
      }
    }, {
      key: "render",
      value: function render() {
        var _this2 = this;

        var _this$state = this.state,
            active = _this$state.active,
            value = _this$state.value,
            min = _this$state.min,
            max = _this$state.max,
            year = _this$state.year;
        var disabled = this.props.disabled;
        var canMoveToNextYear = max ? moment().year(year + 1).isSameOrBefore(max, 'years') : true;
        var canMoveToPrevYear = min ? moment().year(year - 1).isSameOrAfter(min, 'years') : true;
        return React.createElement("div", {
          className: "tc-15-calendar-select-wrap tc-15-calendar2-hook"
        }, React.createElement("div", {
          className: classnames('tc-15-calendar-select tc-15-calendar-month', {
            show: active
          })
        }, React.createElement("button", {
          className: classnames('tc-15-simulate-select tc-15-btn m', {
            show: active,
            disabled: disabled
          }),
          onClick: this.handleShowClick
        }, value.format(this.props.format)), React.createElement("div", {
          className: "tc-15-calendar-triangle-wrap"
        }), React.createElement("div", {
          className: "tc-15-calendar-triangle"
        }), React.createElement("div", {
          className: "tc-15-calendar tc-15-calendar2"
        }, React.createElement("div", {
          className: "tc-15-calendar-cont"
        }, React.createElement("table", {
          className: "tc-15-calendar-mm",
          cellSpacing: "0"
        }, React.createElement("caption", null, year), React.createElement("tbody", null, React.createElement("tr", null, React.createElement("td", {
          colSpan: "2"
        }, React.createElement("i", {
          className: classnames('tc-15-calendar-i-pre-m', {
            disabled: !canMoveToPrevYear
          }),
          tabIndex: "0",
          onClick: function onClick() {
            canMoveToPrevYear && _this2.handleYearChange(-1);
          }
        }, React.createElement("b", null, React.createElement("span", null, canMoveToPrevYear ? '上一年' : '已达最小年份')))), React.createElement("td", {
          colSpan: "2"
        }, React.createElement("i", {
          className: classnames('tc-15-calendar-i-next-m', {
            disabled: !canMoveToNextYear
          }),
          tabIndex: "0",
          onClick: function onClick() {
            canMoveToNextYear && _this2.handleYearChange(+1);
          }
        }, React.createElement("b", null, React.createElement("span", null, canMoveToNextYear ? '下一年' : '已达最大年份'))))), months.map(function (line, index) {
          return React.createElement("tr", {
            key: index
          }, line.map(function (month) {
            var date = moment().year(year).month(month);
            var isBeforeMin = min ? date.isBefore(min, 'months') : false;
            var isAfterMax = max ? date.isAfter(max, 'months') : false;
            var disabled = isBeforeMin || isAfterMax;
            return React.createElement("td", {
              key: month,
              className: classnames({
                'tc-15-calendar-mm-select': value.month() === month,
                'tc-15-calendar-dis': disabled
              }),
              onClick: function onClick() {
                !disabled && _this2.handleMonthChange(date);
              }
            }, date.format('MMM'));
          }));
        })))), React.createElement("div", {
          className: "tc-15-calendar-for-style"
        }))));
      }
    }]);

    return MonthPicker;
  }(React.Component);

  _defineProperty(MonthPicker, "displayName", 'MonthPicker');

  _defineProperty(MonthPicker, "defaultProps", {
    range: {},
    // { min, max }
    value: new Date(),
    format: 'YYYY-MM',
    disabled: false,
    onChange: function onChange() {}
  });

  var MonthPicker$1 = enhanceWithClickOutside(MonthPicker);

  var WeekSelect =
  /*#__PURE__*/
  function (_React$Component) {
    _inherits(WeekSelect, _React$Component);

    function WeekSelect() {
      var _getPrototypeOf2;

      var _this;

      _classCallCheck(this, WeekSelect);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(WeekSelect)).call.apply(_getPrototypeOf2, [this].concat(args)));

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleChange", function (index) {
        var w = _this.weeks[index];

        _this.props.onChange(w.value);
      });

      return _this;
    }

    _createClass(WeekSelect, [{
      key: "render",
      value: function render() {
        var _this2 = this;

        var value = this.props.value;
        var weeks = this.weeks;
        var index = weeks.findIndex(function (w) {
          return +w.value.from === +value.from;
        });
        return React.createElement("select", {
          className: "tc-15-select",
          value: index,
          onChange: function onChange(e) {
            return _this2.handleChange(Number(e.target.value));
          }
        }, weeks.map(function (week, i) {
          return React.createElement("option", {
            value: i,
            key: week.text
          }, week.text);
        }));
      }
    }, {
      key: "weeks",
      get: function get() {
        var start = moment().startOf('week');
        var end = moment();
        end = start.clone().subtract(1, 'd');
        start = start.clone().subtract(7, 'd');
        var ret = [];
        var count = this.props.weekCount;

        while (count > 0) {
          ret.unshift({
            text: start.format('第w周（YYYY-MM-DD）'),
            value: {
              from: start,
              to: end
            }
          });
          end = start.clone().subtract(1, 'd');
          start = start.clone().subtract(7, 'd');
          count--;
        }

        return ret;
      }
    }]);

    return WeekSelect;
  }(React.Component);

  _defineProperty(WeekSelect, "displayName", 'WeekSelect');

  _defineProperty(WeekSelect, "defaultProps", {
    weekCount: 4,
    value: null,
    // 第几周
    onChange: function onChange() {}
  });

  exports.DatePicker = DatePicker$1;
  exports.DateTimePicker = DateTimePicker;
  exports.DateRangePicker = DateRangePicker$1;
  exports.DateTimeRangePicker = DateTimeRangePicker$1;
  exports.DateRangePickerEx = DateRangePickerEx$1;
  exports.DateTimeRangePickerEx = DateTimeRangePickerEx;
  exports.MonthCalendar = MonthCalendar;
  exports.MonthPicker = MonthPicker$1;
  exports.TimePicker = TimePicker$1;
  exports.WeekSelect = WeekSelect;

  exports.DatePickerMMDD = DatePickerMMDD$1;
  exports.MonthCalendarMMDD =MonthCalendarMMDD;
  

  Object.defineProperty(exports, '__esModule', { value: true });

})));
